
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("14ugT", function(module, exports) {

var $at96P = parcelRequire("at96P");


var $iEC7X = parcelRequire("iEC7X");


var $lwpIT = parcelRequire("lwpIT");


var $3om4W = parcelRequire("3om4W");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $7aRa9 = parcelRequire("7aRa9");


var $irVI7 = parcelRequire("irVI7");


var $3XjWl = parcelRequire("3XjWl");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $8nle6 = parcelRequire("8nle6");

const $20ab76b3ff88654d$var$MOVE_TO_PERSONAL_SPACE_FLAG_ID = 'move-to-personal-space-flag';
// All global create dropdown flows share this prefix in their `source` URL param.
const $20ab76b3ff88654d$var$GLOBAL_CREATE_DROPDOWN_PREFIX = 'globalCreateDropdown';
/**
 * Returns the create experience name for the given content type.
 * Each content type has its own tracked experience during creation.
 */ function $20ab76b3ff88654d$var$getCreateExperienceName(contentType) {
    switch(contentType){
        case 'page':
        case 'blogpost':
            return 0, $irVI7.CREATE_PAGE_EXPERIENCE;
        case 'whiteboard':
            return 0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE;
        case 'database':
            return 0, $irVI7.CREATE_DATABASE_EXPERIENCE;
        default:
            return '';
    }
}
function $20ab76b3ff88654d$var$getPostMoveUrl(contentType, spaceKey, contentId, isLivePage = false) {
    if (isLivePage) return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    switch(contentType){
        case 'blogpost':
            return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
                spaceKey: spaceKey,
                contentType: 'blog',
                contentId: contentId
            });
        case 'whiteboard':
            return (0, $1NBp8.WHITEBOARD_BOARD).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'database':
            return (0, $1NBp8.DATABASE_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        default:
            return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
                spaceKey: spaceKey,
                contentType: 'pages',
                contentId: contentId
            });
    }
}
// Module-level set to track which contentIds have already shown the flag this session.
// Prevents re-showing after component remounts (e.g. navigation away and back).
// Resets on full page refresh — same lifecycle as the experience tracker state.
const $20ab76b3ff88654d$var$shownContentIds = new Set();
const $20ab76b3ff88654d$export$907f7ef55acee39a = $20ab76b3ff88654d$var$shownContentIds;
/**
 * Returns an ICU select key for the given content type.
 * Used as the {contentType} variable in i18n messages that use ICU select syntax
 * so translators can provide locale-specific labels for each content type.
 */ function $20ab76b3ff88654d$var$getContentTypeKey(contentType, isLivePage) {
    if (isLivePage) return 'liveDoc';
    switch(contentType){
        case 'page':
            return 'page';
        case 'blogpost':
            return 'blog';
        case 'whiteboard':
            return 'whiteboard';
        case 'database':
            return 'database';
        default:
            return 'other';
    }
}
const $20ab76b3ff88654d$var$i18nMessages = (0, $kSwu1.defineMessages)({
    flagTitle: {
        id: "content-types-utils.move-to-personal-space-flag.title",
        defaultMessage: "Do you want to move this to your own space?"
    },
    flagDescription: {
        id: "content-types-utils.move-to-personal-space-flag.description",
        defaultMessage: "This {contentType, select, page {page} blog {blog} whiteboard {whiteboard} database {database} liveDoc {live doc} other {content}} was created in a shared space. You can move it to your personal space instead."
    },
    moveAction: {
        id: "content-types-utils.move-to-personal-space-flag.move-action",
        defaultMessage: "Move to my space"
    },
    keepAction: {
        id: "content-types-utils.move-to-personal-space-flag.keep-action",
        defaultMessage: "Keep here"
    },
    moveSuccessTitle: {
        id: "content-types-utils.move-to-personal-space-flag.move-success-title",
        defaultMessage: "{contentType, select, page {Page} blog {Blog} whiteboard {Whiteboard} database {Database} liveDoc {Live doc} other {Content}} moved to your space"
    },
    moveErrorTitle: {
        id: "content-types-utils.move-to-personal-space-flag.move-error-title",
        defaultMessage: "Couldn't move {contentType, select, page {page} blog {blog} whiteboard {whiteboard} database {database} liveDoc {live doc} other {content}}"
    },
    moveErrorDescription: {
        id: "content-types-utils.move-to-personal-space-flag.move-error-description",
        defaultMessage: "Something went wrong. Please try moving it manually."
    }
});
const $20ab76b3ff88654d$var$MOVE_PAGE_APPEND_MUTATION = (0, $3om4W.default);
const $20ab76b3ff88654d$var$MOVE_PAGE_TOP_LEVEL_MUTATION = (0, $lwpIT.default);
const $20ab76b3ff88654d$var$MOVE_BLOG_MUTATION = (0, $iEC7X.default);
const $20ab76b3ff88654d$var$SPACE_HOMEPAGE_QUERY = (0, $at96P.default);
const $20ab76b3ff88654d$var$MoveToPersonalSpaceFlagTriggerComponent = ({ contentId: contentId, contentType: contentType, isLivePage: isLivePage, spaceKey: spaceKey, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const contentTypeKey = $20ab76b3ff88654d$var$getContentTypeKey(contentType, isLivePage);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const createExperienceName = $20ab76b3ff88654d$var$getCreateExperienceName(contentType);
    const createExperienceState = (0, $3XjWl.useExperienceState)(createExperienceName);
    // True if content was just created via the global create dropdown and the experience
    // has not failed or been aborted. Excludes page tree and space-level contextual creates.
    // Note: for pages/blogs the experience stops with taskSuccess before the editor mounts,
    // so we allow taskSuccess stops and only guard against taskFail and taskAbort.
    const isNewlyGloballyCreated = !!createExperienceState && createExperienceState.stopState !== 'taskFail' && createExperienceState.stopState !== 'taskAbort' && createExperienceState.attributes?.flow?.startsWith($20ab76b3ff88654d$var$GLOBAL_CREATE_DROPDOWN_PREFIX);
    // Re-use the preloaded personal space query — this data is preloaded during
    // preloadHomeRoute so it should be available in cache instantly.
    // Skip the query entirely when the page is not newly created to avoid
    // unnecessary network requests on regular page visits.
    const { data: personalSpaceDetailsData, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $8nle6.preloadPersonalSpaceDetailsQuery), {
        skip: !isNewlyGloballyCreated,
        __callerPackage__: "content-types-utils"
    });
    // If the user has a personal space, space will be non-null with a key and id.
    // If personal spaces are disabled or user hasn't created one, space will be null.
    const personalSpaceKey = personalSpaceDetailsData?.user?.confluence?.space?.key ?? null;
    const personalSpaceId = personalSpaceDetailsData?.user?.confluence?.space?.id ?? null;
    const hasPersonalSpace = personalSpaceKey !== null && personalSpaceId !== null;
    // Fetch the homepage (overview) page of the user's personal space so we can
    // move the content under it instead of at the space root level
    const { data: homepageData, loading: homepageLoading } = (0, $jMyy4.useQueryInterop)($20ab76b3ff88654d$var$SPACE_HOMEPAGE_QUERY, {
        variables: {
            spaceKey: personalSpaceKey || ''
        },
        skip: !isNewlyGloballyCreated || !hasPersonalSpace,
        __callerPackage__: "content-types-utils"
    });
    const personalSpaceHomepageId = homepageData?.space?.homepage?.id ?? null;
    const [movePageAppend] = (0, $308Wd.useMutationInterop)($20ab76b3ff88654d$var$MOVE_PAGE_APPEND_MUTATION, {
        __callerPackage__: "content-types-utils"
    });
    const [movePageTopLevel] = (0, $308Wd.useMutationInterop)($20ab76b3ff88654d$var$MOVE_PAGE_TOP_LEVEL_MUTATION, {
        __callerPackage__: "content-types-utils"
    });
    const [moveBlog] = (0, $308Wd.useMutationInterop)($20ab76b3ff88654d$var$MOVE_BLOG_MUTATION, {
        __callerPackage__: "content-types-utils"
    });
    // Use refs to avoid stale closures in flag action callbacks
    const personalSpaceKeyRef = (0, $cozmU.useRef)(personalSpaceKey);
    personalSpaceKeyRef.current = personalSpaceKey;
    const personalSpaceIdRef = (0, $cozmU.useRef)(personalSpaceId);
    personalSpaceIdRef.current = personalSpaceId;
    const personalSpaceHomepageIdRef = (0, $cozmU.useRef)(personalSpaceHomepageId);
    personalSpaceHomepageIdRef.current = personalSpaceHomepageId;
    const moveContent = (0, $cozmU.useCallback)(async ()=>{
        const homepageId = personalSpaceHomepageIdRef.current;
        const targetSpaceId = personalSpaceIdRef.current;
        const targetSpaceKey = personalSpaceKeyRef.current;
        switch(contentType){
            case 'blogpost':
                {
                    if (!targetSpaceId) return null;
                    // blogPostId and spaceId are typed as Long! but come as strings — cast as any
                    // to match the pattern used in MoveBlogModal
                    const moveBlogResult = await moveBlog({
                        variables: {
                            blogPostId: contentId,
                            spaceId: targetSpaceId
                        }
                    });
                    return moveBlogResult?.data?.moveBlog?.content?.id ?? null;
                }
            case 'database':
            case 'whiteboard':
            case 'page':
                {
                    if (homepageId) {
                        // Move under the overview/homepage page if it exists
                        const movePageAppendResult = await movePageAppend({
                            variables: {
                                pageId: contentId,
                                parentId: homepageId
                            }
                        });
                        return movePageAppendResult?.data?.movePageAppend?.page?.id ?? null;
                    }
                    if (!targetSpaceKey) return null;
                    // Fall back to top-level move if no homepage exists
                    const movePageTopLevelResult = await movePageTopLevel({
                        variables: {
                            pageId: contentId,
                            spaceKey: targetSpaceKey
                        }
                    });
                    return movePageTopLevelResult?.data?.movePageTopLevel?.page?.id ?? null;
                }
            default:
                return null;
        }
    }, [
        contentType,
        contentId,
        moveBlog,
        movePageAppend,
        movePageTopLevel
    ]);
    const handleMoveToPersonalSpace = (0, $cozmU.useCallback)(async ()=>{
        const targetSpaceKey = personalSpaceKeyRef.current;
        flags.hideFlag($20ab76b3ff88654d$var$MOVE_TO_PERSONAL_SPACE_FLAG_ID);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'moveToPersonalSpaceConfirm',
                source: 'moveToPersonalSpaceFlag',
                attributes: {
                    contentId: contentId,
                    createdInSpaceKey: spaceKey,
                    targetSpaceKey: targetSpaceKey
                }
            }
        }).fire();
        try {
            const movedPageId = await moveContent();
            if (!movedPageId || !targetSpaceKey) throw new Error('Missing move result or target space key');
            flags.showSuccessFlag({
                id: 'move-to-personal-space-success-flag',
                title: formatMessage($20ab76b3ff88654d$var$i18nMessages.moveSuccessTitle, {
                    contentType: contentTypeKey
                }),
                isAutoDismiss: true
            });
            push($20ab76b3ff88654d$var$getPostMoveUrl(contentType, targetSpaceKey, movedPageId, isLivePage));
        } catch  {
            flags.showErrorFlag({
                id: 'move-to-personal-space-error-flag',
                title: formatMessage($20ab76b3ff88654d$var$i18nMessages.moveErrorTitle, {
                    contentType: contentTypeKey
                }),
                description: formatMessage($20ab76b3ff88654d$var$i18nMessages.moveErrorDescription),
                isAutoDismiss: true
            });
        }
    }, [
        flags,
        formatMessage,
        createAnalyticsEvent,
        moveContent,
        push,
        contentId,
        spaceKey,
        contentType,
        isLivePage,
        contentTypeKey
    ]);
    const handleKeepHere = (0, $cozmU.useCallback)(()=>{
        flags.hideFlag($20ab76b3ff88654d$var$MOVE_TO_PERSONAL_SPACE_FLAG_ID);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'moveToPersonalSpaceDismiss',
                source: 'moveToPersonalSpaceFlag',
                attributes: {
                    contentId: contentId,
                    createdInSpaceKey: spaceKey
                }
            }
        }).fire();
    }, [
        flags,
        createAnalyticsEvent,
        contentId,
        spaceKey
    ]);
    const showFlag = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'moveToPersonalSpaceFlagScreen',
                attributes: {
                    contentId: contentId,
                    createdInSpaceKey: spaceKey
                }
            }
        }).fire();
        flags.showInfoFlag({
            id: $20ab76b3ff88654d$var$MOVE_TO_PERSONAL_SPACE_FLAG_ID,
            title: formatMessage($20ab76b3ff88654d$var$i18nMessages.flagTitle),
            description: formatMessage($20ab76b3ff88654d$var$i18nMessages.flagDescription, {
                contentType: contentTypeKey
            }),
            actions: [
                {
                    content: formatMessage($20ab76b3ff88654d$var$i18nMessages.moveAction),
                    onClick: handleMoveToPersonalSpace
                },
                {
                    content: formatMessage($20ab76b3ff88654d$var$i18nMessages.keepAction),
                    onClick: handleKeepHere
                }
            ]
        });
    }, [
        flags,
        formatMessage,
        createAnalyticsEvent,
        contentId,
        spaceKey,
        handleMoveToPersonalSpace,
        handleKeepHere,
        contentTypeKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Only trigger for newly created pages, and wait for all data to be ready
        if (!isNewlyGloballyCreated || loading || homepageLoading || !contentId || !spaceKey) return;
        // Don't show duplicate flags for the same contentId (survives remounts via module-level Set)
        if ($20ab76b3ff88654d$var$shownContentIds.has(contentId)) return;
        // Don't show if user doesn't have a personal space (personal spaces disabled)
        if (!hasPersonalSpace) return;
        // Don't show if content was created in a personal space (starts with ~)
        if (spaceKey.startsWith('~')) return;
        // Don't show if content was created in the user's personal space
        if (spaceKey === personalSpaceKey) return;
        $20ab76b3ff88654d$var$shownContentIds.add(contentId);
        showFlag();
    }, [
        isNewlyGloballyCreated,
        loading,
        homepageLoading,
        contentId,
        spaceKey,
        hasPersonalSpace,
        personalSpaceKey,
        showFlag
    ]);
    return null;
};
const $20ab76b3ff88654d$export$f3508a833a19ce8c = (0, $7aRa9.withFlags)($20ab76b3ff88654d$var$MoveToPersonalSpaceFlagTriggerComponent);
module.exports["MoveToPersonalSpaceFlagTrigger"] = $20ab76b3ff88654d$export$f3508a833a19ce8c;

});

parcelRegister("at96P", function(module, exports) {
/**
 * @generated SignedSource<<b42c4ce52850ad7f68110f1fa523d1dd>>
 * @relayHash 4b5e9dde5572ad2b72b3d90ce64b430b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 39a3fc8907cb86d55c6ae136031c14763a4ab02065d1f2219030a30119b932af
const $4fa5689684608def$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "spaceKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
            v2 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "4b5e9dde5572ad2b72b3d90ce64b430b",
            "id": "39a3fc8907cb86d55c6ae136031c14763a4ab02065d1f2219030a30119b932af",
            "metadata": {},
            "name": "MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery",
            "operationKind": "query",
            "text": "query MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery($spaceKey:String!){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$4fa5689684608def$var$node.hash = "b2693b9e2134a1e0b43171db1726ae37";
var $4fa5689684608def$export$2e2bcd8739ae039 = $4fa5689684608def$var$node;
module.exports["default"] = $4fa5689684608def$export$2e2bcd8739ae039;

});

parcelRegister("iEC7X", function(module, exports) {
/**
 * @generated SignedSource<<672861edb3a467c47872f4baad3d71aa>>
 * @relayHash a681ca4341eb62abd94f1e002744692a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8f19dca02a8c6c08d36848966e224cc2b9ece80fd54f2c467d2e7b7657bc7699
const $f919ec06c3c52f3b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "blogPostId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceId"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "blogPostId",
                    "variableName": "blogPostId"
                },
                {
                    "kind": "Variable",
                    "name": "targetSpaceId",
                    "variableName": "spaceId"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "key"
    }, v4 = {
        "kind": "ScalarField",
        "name": "alias"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MoveToPersonalSpaceFlagTriggerMoveBlogMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "MoveBlogPayload",
                    "kind": "LinkedField",
                    "name": "moveBlog",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MoveToPersonalSpaceFlagTriggerMoveBlogMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "MoveBlogPayload",
                    "kind": "LinkedField",
                    "name": "moveBlog",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "a681ca4341eb62abd94f1e002744692a",
            "id": "8f19dca02a8c6c08d36848966e224cc2b9ece80fd54f2c467d2e7b7657bc7699",
            "metadata": {},
            "name": "MoveToPersonalSpaceFlagTriggerMoveBlogMutation",
            "operationKind": "mutation",
            "text": "mutation MoveToPersonalSpaceFlagTriggerMoveBlogMutation($blogPostId:Long!,$spaceId:Long!){moveBlog(input:{blogPostId:$blogPostId,targetSpaceId:$spaceId}){content{id,space{key,alias,id}}}}"
        }
    };
}();
$f919ec06c3c52f3b$var$node.hash = "93b9a44f4c2595f8a579191b1566d4aa";
var $f919ec06c3c52f3b$export$2e2bcd8739ae039 = $f919ec06c3c52f3b$var$node;
module.exports["default"] = $f919ec06c3c52f3b$export$2e2bcd8739ae039;

});

parcelRegister("lwpIT", function(module, exports) {
/**
 * @generated SignedSource<<8b35d407107d9e66f8970cba2a730460>>
 * @relayHash f7117689bdd81ee360f2b94043895ce4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3b2d43333b298e4930cccff4151dc09b53b23a75941daf6c976d142b379957e2
const $92d8d4dd49e2504c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        },
                        {
                            "kind": "Variable",
                            "name": "targetSpaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MovePagePayload",
            "kind": "LinkedField",
            "name": "movePageTopLevel",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "page",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f7117689bdd81ee360f2b94043895ce4",
            "id": "3b2d43333b298e4930cccff4151dc09b53b23a75941daf6c976d142b379957e2",
            "metadata": {},
            "name": "MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation",
            "operationKind": "mutation",
            "text": "mutation MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation($pageId:ID!,$spaceKey:String!){movePageTopLevel(input:{pageId:$pageId,targetSpaceKey:$spaceKey}){page{id}}}"
        }
    };
}();
$92d8d4dd49e2504c$var$node.hash = "55c2c510926003ccb21aa81ad404b906";
var $92d8d4dd49e2504c$export$2e2bcd8739ae039 = $92d8d4dd49e2504c$var$node;
module.exports["default"] = $92d8d4dd49e2504c$export$2e2bcd8739ae039;

});

parcelRegister("3om4W", function(module, exports) {
/**
 * @generated SignedSource<<b29115b5530334b993269e1e849520a1>>
 * @relayHash af579b7ccd18225f53e0ba7e5997759c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a304af1dcdc7cca397f23a09fa40f823a65f467687010593a4d8d90c922bb448
const $4e5e2421f46e2759$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "parentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        },
                        {
                            "kind": "Variable",
                            "name": "parentId",
                            "variableName": "parentId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MovePagePayload",
            "kind": "LinkedField",
            "name": "movePageAppend",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "page",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MoveToPersonalSpaceFlagTriggerMovePageAppendMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MoveToPersonalSpaceFlagTriggerMovePageAppendMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "af579b7ccd18225f53e0ba7e5997759c",
            "id": "a304af1dcdc7cca397f23a09fa40f823a65f467687010593a4d8d90c922bb448",
            "metadata": {},
            "name": "MoveToPersonalSpaceFlagTriggerMovePageAppendMutation",
            "operationKind": "mutation",
            "text": "mutation MoveToPersonalSpaceFlagTriggerMovePageAppendMutation($pageId:ID!,$parentId:ID!){movePageAppend(input:{pageId:$pageId,parentId:$parentId}){page{id}}}"
        }
    };
}();
$4e5e2421f46e2759$var$node.hash = "79cbc17b214968c2ed046eeef92a15d0";
var $4e5e2421f46e2759$export$2e2bcd8739ae039 = $4e5e2421f46e2759$var$node;
module.exports["default"] = $4e5e2421f46e2759$export$2e2bcd8739ae039;

});

parcelRegister("eU2ry", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6m3nS = parcelRequire("6m3nS");


var $44FuU = parcelRequire("44FuU");


var $bjqPv = parcelRequire("bjqPv");


var $5u9KU = parcelRequire("5u9KU");


var $ilwm5 = parcelRequire("ilwm5");


var $dJQr8 = parcelRequire("dJQr8");


var $5ET5c = parcelRequire("5ET5c");

function $79a354b2f1762f58$export$a270b451500e870a(t0) {
    const $ = (0, $bDgLe.c)(55);
    const { type: type, contentId: contentId } = t0;
    let t1;
    if ($[0] !== type) {
        t1 = {
            type: type
        };
        $[0] = type;
        $[1] = t1;
    } else t1 = $[1];
    const { status: enrollmentStatus, checkEligibility: checkEligibility } = (0, $dJQr8.useFlagToShareEnrollment)(t1);
    let t2;
    if ($[2] !== contentId || $[3] !== type) {
        t2 = {
            contentId: contentId,
            type: type
        };
        $[2] = contentId;
        $[3] = type;
        $[4] = t2;
    } else t2 = $[4];
    const contentSession = t2;
    let t3;
    if ($[5] !== contentId) {
        t3 = {
            contentId: contentId
        };
        $[5] = contentId;
        $[6] = t3;
    } else t3 = $[6];
    const triggerContentSession = t3;
    const [triggeredContentSession, setTriggeredContentSession] = (0, $cozmU.useState)(null);
    const hasTriggered = triggeredContentSession === triggerContentSession;
    const shouldCollectProgress = !hasTriggered && (enrollmentStatus === "unchecked" || enrollmentStatus === "eligible");
    let t4;
    if ($[7] !== contentId || $[8] !== enrollmentStatus || $[9] !== type) {
        t4 = {
            contentId: contentId,
            enrollmentStatus: enrollmentStatus,
            type: type
        };
        $[7] = contentId;
        $[8] = enrollmentStatus;
        $[9] = type;
        $[10] = t4;
    } else t4 = $[10];
    const lifecycleSession = t4;
    const activeContentSessionRef = (0, $cozmU.useRef)(null);
    const triggeredContentSessionRef = (0, $cozmU.useRef)(null);
    const pendingProgressRef = (0, $cozmU.useRef)(null);
    let t5;
    let t6;
    if ($[11] !== contentSession) {
        t5 = ()=>{
            activeContentSessionRef.current = contentSession;
            return ()=>{
                if (activeContentSessionRef.current === contentSession) activeContentSessionRef.current = null;
            };
        };
        t6 = [
            contentSession
        ];
        $[11] = contentSession;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    (0, $cozmU.useLayoutEffect)(t5, t6);
    let hasTriggeredBefore;
    let t7;
    let t8;
    if ($[14] !== type) {
        hasTriggeredBefore = (0, $bjqPv.hasContentTypeTriggeredBefore)(type);
        t8 = (0, $6m3nS.useFirePostOfficeTrigger);
        t7 = (0, $5u9KU.getTriggerId)(type, hasTriggeredBefore);
        $[14] = type;
        $[15] = hasTriggeredBefore;
        $[16] = t7;
        $[17] = t8;
    } else {
        hasTriggeredBefore = $[15];
        t7 = $[16];
        t8 = $[17];
    }
    let t9;
    if ($[18] !== t7) {
        t9 = {
            triggerId: t7
        };
        $[18] = t7;
        $[19] = t9;
    } else t9 = $[19];
    const { fireTrigger: fireTrigger } = t8(t9);
    let t10;
    if ($[20] !== fireTrigger || $[21] !== hasTriggeredBefore || $[22] !== triggerContentSession || $[23] !== type) {
        t10 = ()=>{
            if (triggeredContentSessionRef.current === triggerContentSession) return;
            triggeredContentSessionRef.current = triggerContentSession;
            setTriggeredContentSession(triggerContentSession);
            fireTrigger({
                isActive: true
            });
            if (!hasTriggeredBefore) (0, $bjqPv.markContentTypeTriggered)(type);
        };
        $[20] = fireTrigger;
        $[21] = hasTriggeredBefore;
        $[22] = triggerContentSession;
        $[23] = type;
        $[24] = t10;
    } else t10 = $[24];
    const handleInactivityElapsed = t10;
    const t11 = enrollmentStatus === "eligible" && !hasTriggered;
    let t12;
    if ($[25] !== handleInactivityElapsed || $[26] !== lifecycleSession || $[27] !== t11) {
        t12 = {
            enabled: t11,
            session: lifecycleSession,
            onElapsed: handleInactivityElapsed
        };
        $[25] = handleInactivityElapsed;
        $[26] = lifecycleSession;
        $[27] = t11;
        $[28] = t12;
    } else t12 = $[28];
    const { clear: clearTimer, restart: restartTimer } = (0, $5ET5c.useInactivityTimer)(t12);
    let t13;
    if ($[29] !== clearTimer || $[30] !== restartTimer) {
        t13 = (progress)=>{
            if (!(0, $44FuU.evaluateShareCriteria)(progress)) {
                clearTimer();
                return;
            }
            restartTimer();
        };
        $[29] = clearTimer;
        $[30] = restartTimer;
        $[31] = t13;
    } else t13 = $[31];
    const processEligibleProgress = t13;
    let t14;
    let t15;
    if ($[32] !== contentId || $[33] !== enrollmentStatus || $[34] !== processEligibleProgress || $[35] !== type) {
        t14 = ()=>{
            const pendingProgress = pendingProgressRef.current;
            if (pendingProgress && (pendingProgress.contentId !== contentId || pendingProgress.type !== type)) {
                pendingProgressRef.current = null;
                return;
            }
            if (enrollmentStatus === "ineligible") {
                pendingProgressRef.current = null;
                return;
            }
            if (enrollmentStatus === "eligible" && pendingProgress) {
                pendingProgressRef.current = null;
                processEligibleProgress(pendingProgress.progress);
            }
        };
        t15 = [
            contentId,
            enrollmentStatus,
            processEligibleProgress,
            type
        ];
        $[32] = contentId;
        $[33] = enrollmentStatus;
        $[34] = processEligibleProgress;
        $[35] = type;
        $[36] = t14;
        $[37] = t15;
    } else {
        t14 = $[36];
        t15 = $[37];
    }
    (0, $cozmU.useEffect)(t14, t15);
    let t16;
    if ($[38] !== checkEligibility || $[39] !== clearTimer || $[40] !== contentId || $[41] !== enrollmentStatus || $[42] !== hasTriggered || $[43] !== processEligibleProgress || $[44] !== triggerContentSession || $[45] !== type) {
        t16 = (progress_0)=>{
            if (hasTriggered || triggeredContentSessionRef.current === triggerContentSession) return;
            if (enrollmentStatus === "ineligible") return;
            if (progress_0 === null) {
                pendingProgressRef.current = null;
                clearTimer();
                return;
            }
            if (!(0, $ilwm5.isShareProgressForType)(type, progress_0)) return;
            if (enrollmentStatus === "eligible") {
                processEligibleProgress(progress_0);
                return;
            }
            pendingProgressRef.current = {
                contentId: contentId,
                type: type,
                progress: progress_0
            };
            if (enrollmentStatus === "unchecked") checkEligibility();
        };
        $[38] = checkEligibility;
        $[39] = clearTimer;
        $[40] = contentId;
        $[41] = enrollmentStatus;
        $[42] = hasTriggered;
        $[43] = processEligibleProgress;
        $[44] = triggerContentSession;
        $[45] = type;
        $[46] = t16;
    } else t16 = $[46];
    const notifyCurrentProgress = t16;
    const latestNotifyProgressRef = (0, $cozmU.useRef)(notifyCurrentProgress);
    let t17;
    let t18;
    if ($[47] !== notifyCurrentProgress) {
        t17 = ()=>{
            latestNotifyProgressRef.current = notifyCurrentProgress;
        };
        t18 = [
            notifyCurrentProgress
        ];
        $[47] = notifyCurrentProgress;
        $[48] = t17;
        $[49] = t18;
    } else {
        t17 = $[48];
        t18 = $[49];
    }
    (0, $cozmU.useLayoutEffect)(t17, t18);
    let t19;
    if ($[50] !== contentSession) {
        t19 = (progress_1)=>{
            if (activeContentSessionRef.current !== contentSession) return;
            latestNotifyProgressRef.current(progress_1);
        };
        $[50] = contentSession;
        $[51] = t19;
    } else t19 = $[51];
    const notifyProgress = t19;
    let t20;
    if ($[52] !== notifyProgress || $[53] !== shouldCollectProgress) {
        t20 = {
            shouldCollectProgress: shouldCollectProgress,
            notifyProgress: notifyProgress
        };
        $[52] = notifyProgress;
        $[53] = shouldCollectProgress;
        $[54] = t20;
    } else t20 = $[54];
    return t20;
}
module.exports["useFlagToShare"] = $79a354b2f1762f58$export$a270b451500e870a;

});

parcelRegister("44FuU", function(module, exports) {

var $azjPi = parcelRequire("azjPi");

function $2934374a146272e6$export$b67a8b524073159(progress) {
    switch(progress.type){
        case 'live-doc':
            return progress.wordDelta >= (0, $azjPi.LIVE_DOC_WORDS);
        case 'database':
            return progress.rows > (0, $azjPi.DB_ROWS) && progress.filledCells >= 1 || progress.filledCells > (0, $azjPi.DB_CELLS);
        case 'whiteboard':
            return progress.elements >= (0, $azjPi.WHITEBOARD_OBJECTS);
        default:
            {
                // Exhaustiveness guard: if a new content type is added to the union,
                // this line fails to compile until the switch is updated.
                const _exhaustive = progress;
                return _exhaustive;
            }
    }
}
module.exports["evaluateShareCriteria"] = $2934374a146272e6$export$b67a8b524073159;

});

parcelRegister("azjPi", function(module, exports) {
/**
 * Central tuning constants for the TWCG-2055 "Flag to Share" experiment.
 *
 * Kept in one module so the criteria evaluator, the inactivity timer, and tests
 * all reference the same source of truth.
 */ /**
 * How long editing must stay idle after the criteria are met before the nudge
 * fires. The timer resets on every new progress signal.
 */ const $093f113fb8db0255$export$8f1e82cd4a9a2cbd = 2500;
const $093f113fb8db0255$export$4244f5eddb3836b3 = 100;
const $093f113fb8db0255$export$2283cea0d0bb823c = 3;
const $093f113fb8db0255$export$b604f3263939708a = 3;
const $093f113fb8db0255$export$5cc52e0875dac9a9 = 3;
module.exports["INACTIVITY_MS"] = $093f113fb8db0255$export$8f1e82cd4a9a2cbd;
module.exports["LIVE_DOC_WORDS"] = $093f113fb8db0255$export$4244f5eddb3836b3;
module.exports["DB_ROWS"] = $093f113fb8db0255$export$2283cea0d0bb823c;
module.exports["DB_CELLS"] = $093f113fb8db0255$export$b604f3263939708a;
module.exports["WHITEBOARD_OBJECTS"] = $093f113fb8db0255$export$5cc52e0875dac9a9;

});

parcelRegister("bjqPv", function(module, exports) {

var $1UApO = parcelRequire("1UApO");


var $17wUi = parcelRequire("17wUi");


var $03vGl = parcelRequire("03vGl");

const $ef4426b380e0d10d$var$TRIGGERED_TYPES_KEY = (0, $1UApO.keys).FLAG_TO_SHARE_CRITERIA_MET_TRIGGERED_TYPES;
function $ef4426b380e0d10d$export$6c38df5da8be6f05(type) {
    const rawValue = (0, $17wUi.confluenceLocalStorageInstance).getItem($ef4426b380e0d10d$var$TRIGGERED_TYPES_KEY);
    return (0, $03vGl.hasTypeTriggeredBefore)(rawValue, type);
}
function $ef4426b380e0d10d$export$111ea885207c153f(type) {
    const rawValue = (0, $17wUi.confluenceLocalStorageInstance).getItem($ef4426b380e0d10d$var$TRIGGERED_TYPES_KEY);
    (0, $17wUi.confluenceLocalStorageInstance).setItem($ef4426b380e0d10d$var$TRIGGERED_TYPES_KEY, (0, $03vGl.addTriggeredType)(rawValue, type));
}
module.exports["hasContentTypeTriggeredBefore"] = $ef4426b380e0d10d$export$6c38df5da8be6f05;
module.exports["markContentTypeTriggered"] = $ef4426b380e0d10d$export$111ea885207c153f;

});

parcelRegister("03vGl", function(module, exports) {
const $ff4d3185bfdbd370$var$DELIMITER = ',';
/**
 * Parses the raw `FLAG_TO_SHARE_CRITERIA_MET_TRIGGERED_TYPES` local storage
 * value (a delimited list of `ShareContentType`s) into a `Set`.
 */ function $ff4d3185bfdbd370$var$parseTriggeredTypes(rawValue) {
    const triggeredTypes = new Set();
    if (!rawValue) return triggeredTypes;
    const values = rawValue.split($ff4d3185bfdbd370$var$DELIMITER);
    for (const value of values){
        const trimmed = value.trim();
        if (trimmed) triggeredTypes.add(trimmed);
    }
    return triggeredTypes;
}
function $ff4d3185bfdbd370$export$b35e8ac1d62e5fa7(rawValue, type) {
    return $ff4d3185bfdbd370$var$parseTriggeredTypes(rawValue).has(type);
}
function $ff4d3185bfdbd370$export$d0a83cbe6efb26fb(rawValue, type) {
    const triggeredTypes = $ff4d3185bfdbd370$var$parseTriggeredTypes(rawValue);
    triggeredTypes.add(type);
    return Array.from(triggeredTypes).join($ff4d3185bfdbd370$var$DELIMITER);
}
module.exports["hasTypeTriggeredBefore"] = $ff4d3185bfdbd370$export$b35e8ac1d62e5fa7;
module.exports["addTriggeredType"] = $ff4d3185bfdbd370$export$d0a83cbe6efb26fb;

});

parcelRegister("5u9KU", function(module, exports) {
function $e3b298fe162ebb3e$export$1e04a9a9d2b169fc(contentType, isNth = false) {
    const base = isNth ? 'flag-to-share-criteria-met-nth' : 'flag-to-share-criteria-met';
    return `${base}.${contentType}`;
}
module.exports["getTriggerId"] = $e3b298fe162ebb3e$export$1e04a9a9d2b169fc;

});

parcelRegister("ilwm5", function(module, exports) {
const $15ce7dc150ea5e50$var$isRecord = (value)=>typeof value === 'object' && value !== null;
const $15ce7dc150ea5e50$var$isFiniteNonNegativeNumber = (value)=>typeof value === 'number' && Number.isFinite(value) && value >= 0;
const $15ce7dc150ea5e50$export$94bbd628d4210b42 = (type, value)=>{
    if (!$15ce7dc150ea5e50$var$isRecord(value) || value.type !== type) return false;
    switch(type){
        case 'live-doc':
            return $15ce7dc150ea5e50$var$isFiniteNonNegativeNumber(value.wordDelta);
        case 'whiteboard':
            return $15ce7dc150ea5e50$var$isFiniteNonNegativeNumber(value.elements);
        case 'database':
            return $15ce7dc150ea5e50$var$isFiniteNonNegativeNumber(value.rows) && $15ce7dc150ea5e50$var$isFiniteNonNegativeNumber(value.columns) && $15ce7dc150ea5e50$var$isFiniteNonNegativeNumber(value.filledCells);
        case 'slides':
            return false;
    }
};
module.exports["isShareProgressForType"] = $15ce7dc150ea5e50$export$94bbd628d4210b42;

});

parcelRegister("dJQr8", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");

const $fe533a197392a51a$var$EXPERIMENT_NAME = 'twcg-2055-confluence-onboarding-flag-to-share';
function $fe533a197392a51a$export$898f8ecbe5d92fc7(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { type: type } = t0;
    const [cachedStatus, setCachedStatus] = (0, $cozmU.useState)("unchecked");
    const cachedStatusRef = (0, $cozmU.useRef)("unchecked");
    const activeTypeRef = (0, $cozmU.useRef)(type);
    const isMountedRef = (0, $cozmU.useRef)(false);
    const inFlightCheckRef = (0, $cozmU.useRef)(null);
    const status = type === "slides" ? "ineligible" : cachedStatus;
    let t1;
    let t2;
    if ($[0] !== type) {
        t1 = ()=>{
            activeTypeRef.current = type;
        };
        t2 = [
            type
        ];
        $[0] = type;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            isMountedRef.current = true;
            return ()=>{
                isMountedRef.current = false;
                inFlightCheckRef.current = null;
            };
        };
        t4 = [];
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    (0, $cozmU.useLayoutEffect)(t3, t4);
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            if (activeTypeRef.current === "slides") return Promise.resolve(false);
            if (cachedStatusRef.current === "eligible") return Promise.resolve(true);
            if (cachedStatusRef.current === "ineligible") return Promise.resolve(false);
            const inFlightCheck = inFlightCheckRef.current;
            if (inFlightCheck) return inFlightCheck;
            cachedStatusRef.current = "checking";
            setCachedStatus("checking");
            const promise = Promise.resolve().then(()=>{
                if (!isMountedRef.current) return false;
                return (0, $6mKj3.isExperimentEnabled)($fe533a197392a51a$var$EXPERIMENT_NAME);
            }).catch($fe533a197392a51a$var$_temp).then((isEligible)=>{
                if (isMountedRef.current) {
                    const nextStatus = isEligible ? "eligible" : "ineligible";
                    cachedStatusRef.current = nextStatus;
                    setCachedStatus(nextStatus);
                }
                return isEligible;
            }).finally(()=>{
                if (inFlightCheckRef.current === promise) inFlightCheckRef.current = null;
            });
            inFlightCheckRef.current = promise;
            return promise;
        };
        $[5] = t5;
    } else t5 = $[5];
    const checkEligibility = t5;
    let t6;
    if ($[6] !== status) {
        t6 = {
            status: status,
            checkEligibility: checkEligibility
        };
        $[6] = status;
        $[7] = t6;
    } else t6 = $[7];
    return t6;
}
function $fe533a197392a51a$var$_temp() {
    return false;
}
module.exports["useFlagToShareEnrollment"] = $fe533a197392a51a$export$898f8ecbe5d92fc7;

});

parcelRegister("5ET5c", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $azjPi = parcelRequire("azjPi");

function $2932e93f57b5c02e$export$6af5034a5188c76d(t0) {
    const $ = (0, $bDgLe.c)(16);
    const { enabled: enabled, session: session, onElapsed: onElapsed } = t0;
    const activeSessionRef = (0, $cozmU.useRef)(null);
    const onElapsedRef = (0, $cozmU.useRef)(onElapsed);
    const timerRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== onElapsed) {
        t1 = ()=>{
            onElapsedRef.current = onElapsed;
        };
        t2 = [
            onElapsed
        ];
        $[0] = onElapsed;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            if (timerRef.current !== null) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        };
        $[3] = t3;
    } else t3 = $[3];
    const clearActiveTimer = t3;
    let t4;
    let t5;
    if ($[4] !== enabled || $[5] !== session) {
        t4 = ()=>{
            activeSessionRef.current = session;
            if (!enabled) clearActiveTimer();
            return ()=>{
                if (activeSessionRef.current === session) activeSessionRef.current = null;
                clearActiveTimer();
            };
        };
        t5 = [
            clearActiveTimer,
            enabled,
            session
        ];
        $[4] = enabled;
        $[5] = session;
        $[6] = t4;
        $[7] = t5;
    } else {
        t4 = $[6];
        t5 = $[7];
    }
    (0, $cozmU.useLayoutEffect)(t4, t5);
    let t6;
    if ($[8] !== session) {
        t6 = ()=>{
            if (activeSessionRef.current === session) clearActiveTimer();
        };
        $[8] = session;
        $[9] = t6;
    } else t6 = $[9];
    const clear = t6;
    let t7;
    if ($[10] !== enabled || $[11] !== session) {
        t7 = ()=>{
            if (!enabled || activeSessionRef.current !== session) return;
            clearActiveTimer();
            timerRef.current = setTimeout(()=>{
                if (activeSessionRef.current !== session) return;
                timerRef.current = null;
                onElapsedRef.current();
            }, (0, $azjPi.INACTIVITY_MS));
        };
        $[10] = enabled;
        $[11] = session;
        $[12] = t7;
    } else t7 = $[12];
    const restart = t7;
    let t8;
    if ($[13] !== clear || $[14] !== restart) {
        t8 = {
            clear: clear,
            restart: restart
        };
        $[13] = clear;
        $[14] = restart;
        $[15] = t8;
    } else t8 = $[15];
    return t8;
}
module.exports["useInactivityTimer"] = $2932e93f57b5c02e$export$6af5034a5188c76d;

});

parcelRegister("faVFI", function(module, exports) {

var $5SppV = parcelRequire("5SppV");

function $e69c7ecf0858446f$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $e69c7ecf0858446f$var$id = 0;
function $e69c7ecf0858446f$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $e69c7ecf0858446f$var$id++ + "_" + e;
}
var $e69c7ecf0858446f$var$_flags = /*#__PURE__*/ $e69c7ecf0858446f$var$_classPrivateFieldLooseKey("flags");
class $e69c7ecf0858446f$export$a3823aa64e973105 {
    showFlag(flagProps) {
        $e69c7ecf0858446f$var$_classPrivateFieldLooseBase(this, $e69c7ecf0858446f$var$_flags)[$e69c7ecf0858446f$var$_flags].showFlag({
            ...flagProps,
            customIcon: flagProps.type === 'custom' ? (0, $5SppV.getContentTypesFlagIcon)(flagProps.iconString, flagProps.iconColor, flagProps.profilePicture) : undefined
        });
    }
    hideFlag(flagId) {
        $e69c7ecf0858446f$var$_classPrivateFieldLooseBase(this, $e69c7ecf0858446f$var$_flags)[$e69c7ecf0858446f$var$_flags].hideFlag(flagId);
    }
    constructor(flags){
        Object.defineProperty(this, $e69c7ecf0858446f$var$_flags, {
            writable: true,
            value: void 0
        });
        $e69c7ecf0858446f$var$_classPrivateFieldLooseBase(this, $e69c7ecf0858446f$var$_flags)[$e69c7ecf0858446f$var$_flags] = flags;
    }
}
module.exports["ContentTypesFlagService"] = $e69c7ecf0858446f$export$a3823aa64e973105;

});

parcelRegister("5SppV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $gVrmv = parcelRequire("gVrmv");


var $hMv2K = parcelRequire("hMv2K");


var $fodiz = parcelRequire("fodiz");

const $0c4d6050022a8715$export$1173a795b68d5ee4 = ({ iconString: iconString, iconColor: iconColor, profilePicture: profilePicture })=>{
    let IconComponent;
    switch(iconString){
        case 'feedback':
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($gVrmv)));
            break;
        case 'mention':
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($hMv2K)));
            break;
        case 'avatar':
            return profilePicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                src: profilePicture,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMv2K))), {
                color: "var(--ds-icon, #292A2E)",
                label: ""
            });
        case 'info':
        default:
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($fodiz)));
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
        color: iconColor,
        label: ""
    });
};
const $0c4d6050022a8715$export$15b497b4bcae19f4 = (iconString, iconColor, profilePicture)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0c4d6050022a8715$export$1173a795b68d5ee4, {
        iconString: iconString,
        iconColor: iconColor ?? "var(--ds-icon, #292A2E)",
        profilePicture: profilePicture
    });
module.exports["getContentTypesFlagIcon"] = $0c4d6050022a8715$export$15b497b4bcae19f4;

});

parcelRegister("4RbZ3", function(module, exports) {

var $4qBNn = parcelRequire("4qBNn");

/**
 * Adds a `source` field to a command while preserving its discriminated union member
 */ const $ebcb8f414be8c1a8$var$withSource = (command, source)=>({
        ...command,
        source: source
    });
class $ebcb8f414be8c1a8$export$f3bbb07f64a9b14d {
    dispose() {
        // Using clear here instead of re-assignment to a new map to save memory.
        this.eventHandlers.clear();
        this.eventHandlersByProduct.clear();
    }
    /**
   * This is called in Whiteboards to register the any event callbacks.
   * Confluence FE can then use any of these events to trigger the whiteboard events.
   */ registerEventHandler(event, handler) {
        this.eventHandlers.set(event, handler);
    }
    /**
   * Setup function to be called by a product to register event callbacks. When you use this, you can
   * listen to certain events from other products and NOTIFY other products about certain events
   */ mountEventService(source) {
        /**
     * Expected usage in downstream product:
     * const eventService = contentTypesEventService.mountEventService('whiteboards');
     * eventService.registerHandler('copy', (message) => {
     *   // Handle the copy event
     *   console.log('Whiteboards has been notified about a copy', message);
     * });
     *
     * Invoking a command from another product (e.g., Confluence):
     * const confluenceEventService = contentTypesEventService.mountEventService('confluence');
     * confluenceEventService.sendCommand({
     *  type: 'copy',
     * });
     */ return {
            /**
       * Called by whatever product to mount a listener that will only trigger when OTHER products
       * invoke a command that matches the ContentTypeCommandType.
       */ registerHandler: (event, handler)=>{
                this.eventHandlersByProduct.get(source)?.set(event, handler);
            },
            /**
       * Called by whatever product to unregister a listener that was previously registered
       */ unregisterHandler: (event)=>{
                this.eventHandlersByProduct.get(source)?.delete(event);
            },
            /**
       * Check if an event has any handlers registered to it
       * @param event
       */ hasEventHandler: (event)=>{
                return this.eventHandlersByProduct.get(source)?.has(event);
            },
            /**
       * Trigger an event that OTHER products will receive
       */ sendCommand: (message)=>{
                if (!message || !message.type) return;
                // Call all other sources and notify them that we have triggered an event
                (0, $4qBNn.CONTENT_TYPE_PRODUCT_KEYS).forEach((productKey)=>{
                    // Exclude self. NO SELF TRIGGERING!
                    if (productKey === source) return;
                    this.eventHandlersByProduct.get(productKey)?.get(message.type)?.($ebcb8f414be8c1a8$var$withSource(message, source));
                });
            }
        };
    }
    /**
   * This is called in Whiteboards to unregister the any event callbacks.
   */ unregisterEventHandler(event) {
        this.eventHandlers.delete(event);
    }
    /**
   * Check if an event has any handlers registered to it
   * @param event
   */ hasEventHandler(event) {
        return this.eventHandlers.has(event);
    }
    /**
   * Trigger an event in Whiteboards.
   */ triggerEvent(event) {
        this.eventHandlers.get(event)?.();
    }
    constructor(){
        this.eventHandlers = void 0;
        // Will eventually completely replace V1 event handlers
        this.eventHandlersByProduct = void 0;
        this.eventHandlers = new Map();
        this.eventHandlersByProduct = new Map();
        (0, $4qBNn.CONTENT_TYPE_PRODUCT_KEYS).forEach((key)=>{
            this.eventHandlersByProduct.set(key, new Map());
        });
    }
}
module.exports["ContentTypeEventService"] = $ebcb8f414be8c1a8$export$f3bbb07f64a9b14d;

});

parcelRegister("4qBNn", function(module, exports) {
/**
 * Shared types for `@confluence/content-types-bridge` and its consumers.
 *
 * Lives in a leaf package to avoid circular dependencies. Add types here when
 * they need to be referenced by both the bridge and one or more other
 * Confluence packages.
 */ /**
 * All registered product keys for the cross-product command bus.
 */ const $d218f78abf946e02$export$4ed74be390590078 = [
    'whiteboards',
    'databases',
    'slides',
    'confluence'
];
module.exports["CONTENT_TYPE_PRODUCT_KEYS"] = $d218f78abf946e02$export$4ed74be390590078;

});

parcelRegister("hgdkS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kA6Zo = parcelRequire("kA6Zo");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $3izAL = parcelRequire("3izAL");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $5ZtfK = parcelRequire("5ZtfK");


var $I7hWB = parcelRequire("I7hWB");


var $l3wuH = parcelRequire("l3wuH");


var $kmWRd = parcelRequire("kmWRd");

var $cHiEk = parcelRequire("cHiEk");


var $ai7NK = parcelRequire("ai7NK");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $aCrkK = parcelRequire("aCrkK");


var $eTQu9 = parcelRequire("eTQu9");


var $av0to = parcelRequire("av0to");


var $jpcXR = parcelRequire("jpcXR");


var $3G6jD = parcelRequire("3G6jD");


var $kI68q = parcelRequire("kI68q");

const $641b32b3bb33877e$var$headerTitleStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
});
const $641b32b3bb33877e$var$i18n = (0, $kSwu1.defineMessages)({
    versionHistoryHeaderTitle: {
        id: "version-history.header-title",
        defaultMessage: "Version history"
    },
    versionHistoryCloseButtonLabel: {
        id: "version-history.close.button.icon.label",
        defaultMessage: "Close"
    },
    restoreWhiteboardLabel: {
        id: "version-history.restore.whiteboard.label",
        defaultMessage: "Restore as new whiteboard"
    },
    restoreWhiteboardButtonText: {
        id: "version-history.restore.whiteboard.button.text",
        defaultMessage: "Restore as new whiteboard"
    },
    restoreDatabaseButtonText: {
        id: "version-history.restore.database.button.text",
        defaultMessage: "Restore as new database"
    },
    restoreDatabaseLabel: {
        id: "version-history.restore.database.label",
        defaultMessage: "Restore as new database"
    },
    restoreSlideButtonText: {
        id: "version-history.restore.slide.button.text",
        defaultMessage: "Restore as new slide deck"
    },
    restoreSlideLabel: {
        id: "version-history.restore.slide.label",
        defaultMessage: "Restore as new slide deck"
    }
});
const $641b32b3bb33877e$var$contentTypeMessaging = {
    whiteboard: {
        buttonText: $641b32b3bb33877e$var$i18n.restoreWhiteboardButtonText,
        label: $641b32b3bb33877e$var$i18n.restoreWhiteboardLabel
    },
    database: {
        buttonText: $641b32b3bb33877e$var$i18n.restoreDatabaseButtonText,
        label: $641b32b3bb33877e$var$i18n.restoreDatabaseLabel
    },
    slide: {
        buttonText: $641b32b3bb33877e$var$i18n.restoreSlideButtonText,
        label: $641b32b3bb33877e$var$i18n.restoreSlideLabel
    }
};
const $641b32b3bb33877e$var$VersionHistoryComponent = ({ contentId: contentId, title: title, headerHeight: headerHeight = 0, displayTopBorder: displayTopBorder, panelTop: panelTop = 0, eventService: eventService, setVersion: setVersion, contentType: contentType })=>{
    const { hideSidePanel: hideSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [showRestoreModal, setShowRestoreModal] = (0, $cozmU.useState)(false);
    const { onVersionClick: onVersionClick, onVersionHistoryMenuOpen: onVersionHistoryMenuOpen, onRestoreModalClose: onRestoreModalClose } = (0, $av0to.useVersionHistoryAnalytics)();
    const { autosavedVersions: autosavedVersions, loading: loading, loadMoreVersions: loadMoreVersions, hasNextPage: hasNextPage, cursor: cursor, error: error, refetch: refetch } = (0, $eTQu9.useVersionHistory)({
        contentId: contentId,
        contentType: contentType
    });
    // current version is selected by default
    const [selectedVersion, setSelectedVersion] = (0, $cozmU.useState)(null);
    const { trackExperience: trackExperience } = (0, $aCrkK.useVersionHistoryExperienceTracking)();
    (0, $cozmU.useEffect)(()=>{
        // succeed side panel experience on render
        trackExperience({
            contentType: contentType,
            experience: 'sidePanel',
            task: 'succeed'
        });
    }, [
        contentType,
        trackExperience
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!selectedVersion) setSelectedVersion(null);
    }, [
        setSelectedVersion,
        selectedVersion
    ]);
    (0, $cozmU.useEffect)(()=>{
        onVersionHistoryMenuOpen();
    }, [
        onVersionHistoryMenuOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            setVersion(null);
        };
    }, [
        setVersion
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        onRestoreModalClose();
        setShowRestoreModal(false);
    }, [
        onRestoreModalClose
    ]);
    const handleVersionClick = (0, $cozmU.useCallback)((version)=>{
        setSelectedVersion(version);
        onVersionClick(version);
        setVersion(version || null);
    }, [
        onVersionClick,
        setVersion
    ]);
    // current version does not return externalVersionId
    const isRestoreButtonDisabled = !!error || !selectedVersion?.contentProperties?.latest?.externalVersionId;
    const handleRestoreVersionClick = (0, $cozmU.useCallback)(()=>{
        trackExperience({
            contentType: contentType,
            experience: 'restoreModal',
            task: 'start'
        });
        setShowRestoreModal(true);
    }, [
        contentType,
        trackExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kmWRd.SidePanel), {
        headerHeight: headerHeight,
        displayTopBorder: displayTopBorder,
        panelTop: panelTop
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kI68q.VersionHistoryLoadingPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        backgroundColor: "elevation.surface",
        paddingInlineStart: "space.300",
        paddingInlineEnd: "space.150",
        paddingBlock: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        space: "space.100",
        xcss: $641b32b3bb33877e$var$headerTitleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
        label: "",
        color: "var(--ds-icon, #292A2E)",
        spacing: "none",
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small",
        as: "h5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $641b32b3bb33877e$var$i18n.versionHistoryHeaderTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        onClick: hideSidePanel,
        label: formatMessage($641b32b3bb33877e$var$i18n.versionHistoryCloseButtonLabel)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3G6jD.VersionHistoryContent), {
        autosavedVersions: autosavedVersions,
        hasNextPage: hasNextPage,
        loadMoreVersions: loadMoreVersions,
        cursor: cursor,
        error: error,
        refetch: refetch,
        loading: loading,
        handleVersionClick: handleVersionClick,
        selectedVersion: selectedVersion,
        eventService: eventService,
        contentType: contentType,
        title: title
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cHiEk.SidePanelFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        "aria-label": formatMessage($641b32b3bb33877e$var$contentTypeMessaging[contentType].label),
        shouldFitContainer: true,
        onClick: handleRestoreVersionClick,
        isDisabled: isRestoreButtonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $641b32b3bb33877e$var$contentTypeMessaging[contentType].buttonText))))), showRestoreModal && selectedVersion && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jpcXR.RestoreContentModal), {
        onClose: handleClose,
        selectedVersion: selectedVersion,
        contentType: contentType
    }));
};
const $641b32b3bb33877e$export$bc676b00e8f62584 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
})($641b32b3bb33877e$var$VersionHistoryComponent);
module.exports["VersionHistory"] = $641b32b3bb33877e$export$bc676b00e8f62584;

});

parcelRegister("eTQu9", function(module, exports) {

var $atxcM = parcelRequire("atxcM");


var $jMyy4 = parcelRequire("jMyy4");

const $f24fd770e6b9a487$export$c17d09885b37d368 = ({ contentType: contentType, contentId: contentId })=>{
    const { data: data, loading: loading, error: error, fetchMore: fetchMore, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $atxcM.default), {
        variables: {
            contentId: contentId,
            filter: {
                contentType: contentType
            }
        },
        __callerPackage__: "version-history"
    });
    const startCursor = data?.contentVersionHistory?.pageInfo?.startCursor || null;
    const hasNextPage = data?.contentVersionHistory?.pageInfo?.hasNextPage || false;
    const autosavedVersions = data?.contentVersionHistory?.nodes || [];
    const loadMoreVersions = ()=>{
        if (hasNextPage && startCursor && !loading) fetchMore({
            variables: {
                contentId: contentId,
                filter: {
                    contentType: contentType
                },
                after: startCursor
            },
            updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
                if (!fetchMoreResult?.contentVersionHistory) return prev;
                const prevNodes = prev?.contentVersionHistory?.nodes || [];
                const fetchedNodes = fetchMoreResult.contentVersionHistory.nodes || [];
                const pageInfo = fetchMoreResult.contentVersionHistory.pageInfo || prev?.contentVersionHistory?.pageInfo;
                return {
                    contentVersionHistory: {
                        nodes: [
                            ...prevNodes,
                            ...fetchedNodes
                        ],
                        pageInfo: pageInfo,
                        __typename: 'ContentVersionHistoryConnection'
                    }
                };
            }
        });
    };
    return {
        autosavedVersions: autosavedVersions,
        loading: loading,
        error: error,
        loadMoreVersions: loadMoreVersions,
        cursor: startCursor,
        hasNextPage: hasNextPage,
        refetch: refetch
    };
};
module.exports["useVersionHistory"] = $f24fd770e6b9a487$export$c17d09885b37d368;

});

parcelRegister("atxcM", function(module, exports) {
/**
 * @generated SignedSource<<83d2b516fd052c39df286caf192a4af8>>
 * @relayHash 46f552cbc164e70ef5b6a465d63f2187
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d37f74ef8d6e6c2d02f319780a3256ecd050e611ebd2aee6b76e8ebae6c5a25
const $ef96565a18526431$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                },
                {
                    "kind": "Variable",
                    "name": "filter",
                    "variableName": "filter"
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 30
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentVersionHistoryConnection",
            "kind": "LinkedField",
            "name": "contentVersionHistory",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentVersion",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "AtlassianUser",
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isActive"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "updatedTime"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PublishedContentProperties",
                                    "kind": "LinkedField",
                                    "name": "latest",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "externalVersionId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "versionContainsAIContent"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ContentVersionHistoryPageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasPreviousPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "startCursor"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useVersionHistoryContentVersionHistoryQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useVersionHistoryContentVersionHistoryQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "46f552cbc164e70ef5b6a465d63f2187",
            "id": "3d37f74ef8d6e6c2d02f319780a3256ecd050e611ebd2aee6b76e8ebae6c5a25",
            "metadata": {},
            "name": "useVersionHistoryContentVersionHistoryQuery",
            "operationKind": "query",
            "text": "query useVersionHistoryContentVersionHistoryQuery($contentId:ID!,$filter:ContentVersionHistoryFilter!,$after:String){contentVersionHistory(id:$contentId,after:$after,first:30,filter:$filter){nodes{author{id,isActive,displayName},contentId,number,updatedTime,contentProperties{latest{externalVersionId,versionContainsAIContent}}},pageInfo{hasNextPage,hasPreviousPage,startCursor,endCursor}}}"
        }
    };
}();
$ef96565a18526431$var$node.hash = "296aa31263754473c2bb2fd3016f2336";
var $ef96565a18526431$export$2e2bcd8739ae039 = $ef96565a18526431$var$node;
module.exports["default"] = $ef96565a18526431$export$2e2bcd8739ae039;

});

parcelRegister("av0to", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $ep3mz = parcelRequire("ep3mz");

const $bac38a4aff776821$export$8fea35734ad69528 = ()=>{
    const [{ contentType: contentType, contentId: contentId }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onVersionClick = (0, $cozmU.useCallback)((version)=>{
        if (version) {
            const { updatedTime: updatedTime, number: number } = version;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'version',
                    actionSubjectId: 'selected',
                    source: 'versionHistoryScreen',
                    objectId: contentId,
                    objectType: contentType,
                    attributes: {
                        updatedTime: updatedTime,
                        number: number
                    }
                }
            }).fire();
        } else createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'version',
                actionSubjectId: 'current',
                source: 'versionHistoryScreen',
                objectId: contentId,
                objectType: contentType
            }
        }).fire();
    }, [
        contentId,
        contentType,
        createAnalyticsEvent
    ]);
    const onVersionHistoryMenuOpen = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'versionHistoryScreen',
                attributes: {
                    objectType: contentType,
                    objectId: contentId
                }
            }
        }).fire();
    }, [
        contentId,
        contentType,
        createAnalyticsEvent
    ]);
    const onCopyVersionContent = (0, $cozmU.useCallback)((version)=>{
        const { updatedTime: updatedTime, number: number } = version;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'copyVersionContent',
                source: 'versionHistoryScreen',
                objectId: contentId,
                objectType: contentType,
                attributes: {
                    updatedTime: updatedTime,
                    number: number
                }
            }
        }).fire();
    }, [
        contentId,
        contentType,
        createAnalyticsEvent
    ]);
    const onRestore = (0, $cozmU.useCallback)((version)=>{
        const { updatedTime: updatedTime, number: number } = version;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'restore',
                objectId: contentId,
                objectType: contentType,
                source: 'versionHistoryModal',
                attributes: {
                    updatedTime: updatedTime,
                    number: number
                }
            }
        }).fire();
    }, [
        contentId,
        contentType,
        createAnalyticsEvent
    ]);
    const onRestoreModalClose = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'closeButton',
                source: 'versionHistoryScreen',
                objectId: contentId,
                objectType: contentType
            }
        }).fire();
    }, [
        contentId,
        contentType,
        createAnalyticsEvent
    ]);
    return {
        onVersionClick: onVersionClick,
        onVersionHistoryMenuOpen: onVersionHistoryMenuOpen,
        onCopyVersionContent: onCopyVersionContent,
        onRestore: onRestore,
        onRestoreModalClose: onRestoreModalClose
    };
};
module.exports["useVersionHistoryAnalytics"] = $bac38a4aff776821$export$8fea35734ad69528;

});

parcelRegister("jpcXR", function(module, exports) {

var $1UkQU = parcelRequire("1UkQU");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7aRdF = parcelRequire("7aRdF");


var $9Umtx = parcelRequire("9Umtx");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $I7hWB = parcelRequire("I7hWB");


var $6Pqow = parcelRequire("6Pqow");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $ad7Ou = parcelRequire("ad7Ou");


var $1VhsF = parcelRequire("1VhsF");


var $308Wd = parcelRequire("308Wd");


var $50sHn = parcelRequire("50sHn");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $caYQd = parcelRequire("caYQd");


var $lqy4C = parcelRequire("lqy4C");


var $ai7NK = parcelRequire("ai7NK");


var $b3j2Y = parcelRequire("b3j2Y");


var $aCrkK = parcelRequire("aCrkK");


var $ck0S9 = parcelRequire("ck0S9");


var $av0to = parcelRequire("av0to");


var $ktuvZ = parcelRequire("ktuvZ");

const $3e7e8a0093eea0b3$var$i18n = (0, $kSwu1.defineMessages)({
    restoreContentTitle: {
        id: "version-history.restore.content.title",
        defaultMessage: "Restore"
    },
    restoreButton: {
        id: "version-history.restore.button",
        defaultMessage: "Restore"
    },
    whiteboardInfoBoxText: {
        id: "version-history.info.box.text",
        defaultMessage: "When restoring a board, permission and share settings remain the same."
    },
    saveWorkWithoutCreatingText: {
        id: "version-history.save-work-without-creating.text",
        defaultMessage: "To save work without creating, try copying content from the whiteboard to an editable whiteboard."
    },
    spaceSelectorLabel: {
        id: "version-history.space-selector.label",
        defaultMessage: "Select space"
    },
    whiteboardPlaceholderTitle: {
        id: "version-history.placeholder.whiteboard.title",
        defaultMessage: "[Restored] Untitled board {date}"
    },
    duplicateTitleErrorTitle: {
        id: "version-history.restore-modal.conflicting-title-error-title",
        defaultMessage: "Duplicate title in this space"
    },
    newDuplicateTitleErrorBody: {
        id: "version-history.restore-modal.new-conflicting-title-error-body",
        defaultMessage: "To continue restoring, create a unique title or try adding it to a different space."
    },
    spacePermissionErrorTitle: {
        id: "version-history.restore-modal.space-permission-error-title",
        defaultMessage: "You don\u2019t have space access"
    },
    newSpacePermissionErrorBody: {
        id: "version-history.restore-modal.new-space-permission-error-body",
        defaultMessage: "To restore this content, you\u2019ll need permissions to <b>Create</b> in this space."
    },
    genericErrorTitle: {
        id: "version-history.restore-modal.generic-error-title",
        defaultMessage: "We couldn\u2019t complete your request"
    },
    genericErrorBody: {
        id: "version-history.restore-modal.generic-error-body",
        defaultMessage: "Try refreshing the page, or check your network connection."
    },
    databasePlaceholderTitle: {
        id: "version-history.placeholder.database.title",
        defaultMessage: "[Restored] Untitled database {date}"
    },
    databaseInfoBoxText: {
        id: "version-history.database.info.box.text",
        defaultMessage: "When restoring a database, permission and share settings remain the same."
    },
    slidePlaceholderTitle: {
        id: "version-history.placeholder.slide.title",
        defaultMessage: "[Restored] Untitled slide deck {date}"
    },
    slideInfoBoxText: {
        id: "version-history.slide.info.box.text",
        defaultMessage: "When restoring a slide deck, permission and share settings remain the same."
    }
});
const $3e7e8a0093eea0b3$var$restoreContentModalMessaging = {
    whiteboard: {
        description: $3e7e8a0093eea0b3$var$i18n.whiteboardInfoBoxText,
        placeholderTitle: $3e7e8a0093eea0b3$var$i18n.whiteboardPlaceholderTitle
    },
    database: {
        description: $3e7e8a0093eea0b3$var$i18n.databaseInfoBoxText,
        placeholderTitle: $3e7e8a0093eea0b3$var$i18n.databasePlaceholderTitle
    },
    slide: {
        description: $3e7e8a0093eea0b3$var$i18n.slideInfoBoxText,
        placeholderTitle: $3e7e8a0093eea0b3$var$i18n.slidePlaceholderTitle
    }
};
const $3e7e8a0093eea0b3$var$EXPECTED_ERROR_MESSAGE = {
    duplicateTitle: 'exists with the same title in this space',
    spacePermissions: '.PermissionException: Could not create content'
};
const $3e7e8a0093eea0b3$var$errorSectionMessageStyles = (0, $buxP3.xcss)({
    marginBottom: 'space.100'
});
const $3e7e8a0093eea0b3$var$ErrorSectionMessage = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let errorTitle;
    let errorBody;
    if (!error) return null;
    if (error.message.includes($3e7e8a0093eea0b3$var$EXPECTED_ERROR_MESSAGE.duplicateTitle)) {
        errorTitle = $3e7e8a0093eea0b3$var$i18n.duplicateTitleErrorTitle;
        errorBody = $3e7e8a0093eea0b3$var$i18n.newDuplicateTitleErrorBody;
    } else if (error.message.includes($3e7e8a0093eea0b3$var$EXPECTED_ERROR_MESSAGE.spacePermissions)) {
        errorTitle = $3e7e8a0093eea0b3$var$i18n.spacePermissionErrorTitle;
        errorBody = $3e7e8a0093eea0b3$var$i18n.newSpacePermissionErrorBody;
    } else {
        errorTitle = $3e7e8a0093eea0b3$var$i18n.genericErrorTitle;
        errorBody = $3e7e8a0093eea0b3$var$i18n.genericErrorBody;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $3e7e8a0093eea0b3$var$errorSectionMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        appearance: "error",
        title: formatMessage(errorTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...errorBody,
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
        }
    }))));
};
const $3e7e8a0093eea0b3$export$63ec0fdbb660e929 = ({ onClose: onClose, selectedVersion: selectedVersion, contentType: contentType })=>{
    const { formatMessage: formatMessage, formatDate: formatDate, formatTime: formatTime } = (0, $kSwu1.useIntl)();
    const { onRestore: onRestore } = (0, $av0to.useVersionHistoryAnalytics)();
    const selectedVersionDate = (0, $ck0S9.getFormattedDate)(selectedVersion.updatedTime, formatDate, formatTime);
    // use current space as default space key
    const [{ spaceKey: spaceKey, contentId: contentId }] = (0, $ep3mz.usePageState)();
    const [destinationSpaceKey, setDestinationSpaceKey] = (0, $cozmU.useState)(spaceKey);
    const [title, setTitle] = (0, $cozmU.useState)(formatMessage($3e7e8a0093eea0b3$var$restoreContentModalMessaging[contentType].placeholderTitle, {
        date: selectedVersionDate
    }));
    const [restoreError, setRestoreError] = (0, $cozmU.useState)(null);
    const [restoreIsActive, setRestoreIsActive] = (0, $cozmU.useState)(false);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'restore-content-modal'
    });
    const { selectedSpaceClassification: selectedSpaceClassification, classificationError: classificationError } = (0, $50sHn.useClassificationChangeState)(String(contentId), destinationSpaceKey, spaceKey);
    const { hideSidePanel: hideSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const requiredSpaceOperations = [
        {
            targetType: 'page',
            operation: 'create'
        }
    ];
    const onSpaceSelectorChange = (selectedSpace)=>{
        const { spaceKey: selectedSpaceKey } = selectedSpace;
        setDestinationSpaceKey(selectedSpaceKey);
    };
    const { trackExperience: trackExperience } = (0, $aCrkK.useVersionHistoryExperienceTracking)();
    const [restoreVersion] = (0, $308Wd.useMutationInterop)((0, $1UkQU.default), {
        onCompleted: (data)=>{
            setRestoreIsActive(false);
            const contentUrl = `${data?.createContentContextual?.links?.context}${data?.createContentContextual?.links?.webui}?flow=restoreVersion`;
            trackExperience({
                contentType: contentType,
                experience: 'restoreExperience',
                task: 'start'
            });
            onRestore(selectedVersion);
            hideSidePanel();
            push(contentUrl);
        },
        onError: (graphqlError)=>{
            setRestoreIsActive(false);
            setRestoreError(graphqlError);
        },
        __callerPackage__: "version-history"
    });
    const handleRestoreClick = (0, $cozmU.useCallback)(()=>{
        setRestoreIsActive(true);
        setRestoreError(null);
        restoreVersion({
            variables: {
                spaceKey: destinationSpaceKey,
                title: title,
                type: contentType,
                restoreVersionContentId: selectedVersion.contentId
            }
        });
    }, [
        restoreVersion,
        destinationSpaceKey,
        title,
        contentType,
        selectedVersion
    ]);
    (0, $cozmU.useEffect)(()=>{
        // succeed restore modal load experience on render
        trackExperience({
            contentType: contentType,
            experience: 'restoreModal',
            task: 'succeed'
        });
    }, [
        contentType,
        trackExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        testId: "restore-content-modal",
        width: "400px",
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium",
        as: "h6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3e7e8a0093eea0b3$var$i18n.restoreContentTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3e7e8a0093eea0b3$var$ErrorSectionMessage, {
        error: restoreError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        size: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3e7e8a0093eea0b3$var$restoreContentModalMessaging[contentType].description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ktuvZ.VersionTitleUpdate), {
        title: title,
        setTitle: setTitle,
        contentType: contentType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $caYQd.SpaceSelector), {
        onChange: onSpaceSelectorChange,
        operationsUsedToDetermineRestrictedStatus: requiredSpaceOperations,
        showRestrictedSpaces: false,
        filterDefaultFromResults: false,
        spaceKey: destinationSpaceKey,
        labelTextTransform: "none",
        useMenuPortalTarget: true,
        spaceClassification: selectedSpaceClassification,
        hasClassificationError: !!classificationError,
        selectStyleOverrides: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: 9999
                })
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: enforceStorageLimit(handleRestoreClick),
        isLoading: restoreIsActive,
        isDisabled: restoreIsActive,
        testId: "restore-content-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3e7e8a0093eea0b3$var$i18n.restoreButton))));
};
module.exports["RestoreContentModal"] = $3e7e8a0093eea0b3$export$63ec0fdbb660e929;

});

parcelRegister("1UkQU", function(module, exports) {
/**
 * @generated SignedSource<<0961a74ad59b458a6777316d24c93a6f>>
 * @relayHash 85b048c98f58c3903ed23f74fbf507f8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 64ce200dcf2252808b6f2534a27984730b37ac99ba9eb4c6faef6129ab071331
const $578255423823f8b5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "restoreVersionContentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "title"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v4 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "items": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "restoreVersionContentId"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "value",
                                            "variableName": "restoreVersionContentId"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "contentSpecificCreateInput.0"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "contentSpecificCreateInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        },
                        {
                            "kind": "Literal",
                            "name": "status",
                            "value": "CURRENT"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "title"
                        },
                        {
                            "kind": "Variable",
                            "name": "type",
                            "variableName": "type"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "createContentContextual",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "context"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RestoreContentModalRestoreContentMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RestoreContentModalRestoreContentMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "85b048c98f58c3903ed23f74fbf507f8",
            "id": "64ce200dcf2252808b6f2534a27984730b37ac99ba9eb4c6faef6129ab071331",
            "metadata": {},
            "name": "RestoreContentModalRestoreContentMutation",
            "operationKind": "mutation",
            "text": "mutation RestoreContentModalRestoreContentMutation($spaceKey:String!,$restoreVersionContentId:String!,$title:String,$type:String!){createContentContextual(input:{spaceKey:$spaceKey,contentSpecificCreateInput:[{key:\"restoreVersionContentId\",value:$restoreVersionContentId}],status:CURRENT,title:$title,type:$type}){id,links{context,webui}}}"
        }
    };
}();
$578255423823f8b5$var$node.hash = "7802992675fb7028e2a9b80023fd6854";
var $578255423823f8b5$export$2e2bcd8739ae039 = $578255423823f8b5$var$node;
module.exports["default"] = $578255423823f8b5$export$2e2bcd8739ae039;

});

parcelRegister("ck0S9", function(module, exports) {
const $a0d25f7e92df57be$export$92521769c5df59ad = (dateInputString, formatDate, formatTime)=>{
    const dateString = new Date(dateInputString);
    const formattedDate = formatDate(dateString, {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
    const formattedTime = formatTime(dateString, {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    });
    return `${formattedDate} ${formattedTime.replace('AM', 'a.m.').replace('PM', 'p.m.')}`;
};
module.exports["getFormattedDate"] = $a0d25f7e92df57be$export$92521769c5df59ad;

});

parcelRegister("ktuvZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dUI0h = parcelRequire("dUI0h");


var $7BfeF = parcelRequire("7BfeF");


var $hpa99 = parcelRequire("hpa99");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $4yg9g = parcelRequire("4yg9g");

const $bd5348f98ee50a88$var$MAX_TITLE_NAME_LENGTH = 60;
const $bd5348f98ee50a88$var$i18n = (0, $kSwu1.defineMessages)({
    whiteboardTitle: {
        id: "version-history.whiteboard-title",
        defaultMessage: "Whiteboard title"
    },
    titleLengthError: {
        id: "version-history.title.length.error",
        defaultMessage: "{maxLength, plural, one {Title has a maximum of {maxLength} character} other {Title has a maximum of {maxLength} characters}}"
    },
    databaseTitle: {
        id: "version-history.database-title",
        defaultMessage: "Database title"
    },
    slideTitle: {
        id: "version-history.slide-title",
        defaultMessage: "Slide deck title"
    }
});
const $bd5348f98ee50a88$var$titleUpdateMessaging = {
    whiteboard: $bd5348f98ee50a88$var$i18n.whiteboardTitle,
    database: $bd5348f98ee50a88$var$i18n.databaseTitle,
    slide: $bd5348f98ee50a88$var$i18n.slideTitle
};
const $bd5348f98ee50a88$var$labelComponentStyle = (0, $buxP3.xcss)({
    marginBottom: 'space.100',
    color: 'color.text.subtlest'
});
const $bd5348f98ee50a88$var$LabelComponent = ({ contentType: contentType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $bd5348f98ee50a88$var$labelComponentStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bd5348f98ee50a88$var$titleUpdateMessaging[contentType]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null));
const $bd5348f98ee50a88$export$68f60d0fda17fe94 = ({ title: title, setTitle: setTitle, contentType: contentType })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [hasError, setHasError] = (0, $cozmU.useState)(false);
    const handleTitleChange = (e)=>{
        const value = e.target.value;
        if (value.length <= $bd5348f98ee50a88$var$MAX_TITLE_NAME_LENGTH) {
            setTitle(value);
            setHasError(false);
        } else setHasError(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd5348f98ee50a88$var$LabelComponent, {
            contentType: contentType
        }),
        name: "version-title"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            ...fieldProps,
            value: title,
            onChange: handleTitleChange,
            maxLength: $bd5348f98ee50a88$var$MAX_TITLE_NAME_LENGTH + 1,
            autoComplete: "off",
            isInvalid: hasError,
            testId: "version-title-input"
        })), hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, formatMessage($bd5348f98ee50a88$var$i18n.titleLengthError, {
        maxLength: $bd5348f98ee50a88$var$MAX_TITLE_NAME_LENGTH
    })));
};
module.exports["VersionTitleUpdate"] = $bd5348f98ee50a88$export$68f60d0fda17fe94;

});

parcelRegister("3G6jD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $buxP3 = parcelRequire("buxP3");


var $2wCqQ = parcelRequire("2wCqQ");


var $3izAL = parcelRequire("3izAL");


var $6Pqow = parcelRequire("6Pqow");


var $4B2M3 = parcelRequire("4B2M3");


var $b3j2Y = parcelRequire("b3j2Y");


var $1ggpj = parcelRequire("1ggpj");


var $av0to = parcelRequire("av0to");


var $cI2Ba = parcelRequire("cI2Ba");


var $8DoOG = parcelRequire("8DoOG");

const $3210ac4b9f221c74$var$i18n = (0, $kSwu1.defineMessages)({
    currentVersionTitle: {
        id: "version-history.current.version.title",
        defaultMessage: "Current version"
    },
    autoSavedVersionsTitle: {
        id: "version-history.auto-saved.version.title",
        defaultMessage: "Autosaved versions"
    },
    historyAvailabilityInfo: {
        id: "version-history.history.availability.info",
        defaultMessage: "Whiteboards history is available for the past 30 days."
    },
    slideHistoryAvailabilityInfo: {
        id: "version-history.slide.history.availability.info",
        defaultMessage: "Slides history is available for the past 30 days."
    },
    databasehHistoryAvailabilityInfo: {
        id: "version-history.database.history.availability.info",
        defaultMessage: "Databases history is available for the past 30 days."
    }
});
const $3210ac4b9f221c74$var$contentTypeMessaging = {
    whiteboard: $3210ac4b9f221c74$var$i18n.historyAvailabilityInfo,
    slide: $3210ac4b9f221c74$var$i18n.slideHistoryAvailabilityInfo,
    database: $3210ac4b9f221c74$var$i18n.databasehHistoryAvailabilityInfo
};
const $3210ac4b9f221c74$var$bodyContentWrapperStyles = (0, $buxP3.xcss)({
    overflowY: 'auto',
    flexGrow: 1
});
const $3210ac4b9f221c74$var$SectionTitle = ({ title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        paddingBlock: "space.100",
        paddingInlineStart: "space.300",
        paddingInlineEnd: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), title)));
const $3210ac4b9f221c74$export$23bb3757bf428071 = ({ error: error, autosavedVersions: autosavedVersions, hasNextPage: hasNextPage, loadMoreVersions: loadMoreVersions, cursor: cursor, refetch: refetch, loading: loading, handleVersionClick: handleVersionClick, selectedVersion: selectedVersion, eventService: eventService, contentType: contentType, title: title })=>{
    const { onCopyVersionContent: onCopyVersionContent } = (0, $av0to.useVersionHistoryAnalytics)();
    // certain browsers may not allow copying
    // only whiteboards support copying content
    const isCopyAllowed = (0, $1ggpj.isCanvasContentType)(contentType) && eventService.hasEventHandler('copy');
    const handleCopyClick = (0, $cozmU.useCallback)(()=>{
        eventService.triggerEvent('copy');
        if (selectedVersion) onCopyVersionContent(selectedVersion);
    }, [
        eventService,
        selectedVersion,
        onCopyVersionContent
    ]);
    if (error && !loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8DoOG.ErrorState), {
        refetch: refetch
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $3210ac4b9f221c74$var$bodyContentWrapperStyles,
        "data-testId": "version-history-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3210ac4b9f221c74$var$SectionTitle, {
        title: $3210ac4b9f221c74$var$i18n.currentVersionTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cI2Ba.VersionHistoryCurrentVersionItem), {
        handleVersionClick: handleVersionClick,
        isSelected: !selectedVersion,
        title: title
    })), autosavedVersions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3210ac4b9f221c74$var$SectionTitle, {
        title: $3210ac4b9f221c74$var$i18n.autoSavedVersionsTitle
    }), autosavedVersions.map((version)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cI2Ba.VersionHistoryItem), {
            version: version,
            key: version.number,
            handleVersionClick: handleVersionClick,
            isSelected: version.number === selectedVersion?.number,
            isCopyAllowed: isCopyAllowed,
            handleCopyClick: handleCopyClick
        });
    }), hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4B2M3.ObservableSpinner), {
        cursor: cursor,
        testId: "version-history-loading-spinner",
        onScrollTo: loadMoreVersions,
        observerOptions: {
            root: null,
            rootMargin: '0px',
            threshold: 0.05
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        paddingBlock: "space.200",
        paddingInlineEnd: "space.200",
        paddingInlineStart: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        align: "center",
        as: "p",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3210ac4b9f221c74$var$contentTypeMessaging[contentType]))));
};
module.exports["VersionHistoryContent"] = $3210ac4b9f221c74$export$23bb3757bf428071;

});

parcelRegister("cI2Ba", function(module, exports) {
/* VersionHistoryItem.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6Pqow = parcelRequire("6Pqow");


var $2wCqQ = parcelRequire("2wCqQ");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $3izAL = parcelRequire("3izAL");


var $1sCHt = parcelRequire("1sCHt");


var $fHs3z = parcelRequire("fHs3z");


var $lpNn5 = parcelRequire("lpNn5");


var $9d7Pd = parcelRequire("9d7Pd");


var $9KSWX = parcelRequire("9KSWX");


var $9wGTI = parcelRequire("9wGTI");


var $ck0S9 = parcelRequire("ck0S9");

const $073a675ae869dda9$var$i18n = (0, $kSwu1.defineMessages)({
    currentVersionDescription: {
        id: "version-history.current.version.description",
        defaultMessage: "Most recently saved"
    },
    copyIconLabel: {
        id: "version-history.copy.icon.label",
        defaultMessage: "Copy icon"
    },
    copyIconTooltip: {
        id: "version-history.copy.icon.tooltip",
        defaultMessage: "Copy all content"
    },
    copyIconTooltipCopied: {
        id: "version-history.copy.icon.tooltip-copied",
        defaultMessage: "Copied!"
    },
    lastEditedByLabel: {
        id: "version-history.author.last-edited-by.label",
        defaultMessage: "Last edited by {author}"
    },
    lastEditedByAnonymousUserLabel: {
        id: "version-history.author.last-edited-by-anonymous-user.label",
        defaultMessage: "Last edited by Anonymous"
    },
    lastEditedByDeactivatedUserLabel: {
        id: "version-history.author.last-edited-by-deactivated-user.label",
        defaultMessage: "Last edited by {author} (Deactivated)"
    },
    versionContainsAIContentTooltip: {
        id: "version-history.lozenge.version-contains-ai-content.tooltip",
        defaultMessage: "This version includes AI generated content"
    },
    aiContentText: {
        id: "version-history.lozenge.ai-content-text",
        defaultMessage: "AI Generated"
    }
});
const $073a675ae869dda9$var$styles = {
    customStylesContainer: "_4bt5LAnQyn _2WAcuGnQyn _39xV02AK7l _39HuIbz8Lp"
};
const $073a675ae869dda9$var$itemContainerStyles = (0, $buxP3.xcss)({
    paddingLeft: 'space.100'
});
const $073a675ae869dda9$export$15c96dc1a83defb4 = ({ handleVersionClick: handleVersionClick, isSelected: isSelected, title: title })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        isSelected: isSelected,
        testId: "version-history-item",
        onClick: ()=>handleVersionClick(null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        alignBlock: "center",
        spread: "space-between",
        xcss: $073a675ae869dda9$var$itemContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        size: "medium"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        size: "small",
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $073a675ae869dda9$var$i18n.currentVersionDescription)))));
};
const $073a675ae869dda9$export$e0ca0449ea662b5 = ({ version: version, handleVersionClick: handleVersionClick, isSelected: isSelected, isCopyAllowed: isCopyAllowed, handleCopyClick: handleCopyClick })=>{
    const { formatMessage: formatMessage, formatDate: formatDate, formatTime: formatTime } = (0, $kSwu1.useIntl)();
    const versionContainsAIContentTooltip = formatMessage($073a675ae869dda9$var$i18n.versionContainsAIContentTooltip);
    const aiContentText = formatMessage($073a675ae869dda9$var$i18n.aiContentText);
    const copyAllContentText = formatMessage($073a675ae869dda9$var$i18n.copyIconTooltip);
    const copiedText = formatMessage($073a675ae869dda9$var$i18n.copyIconTooltipCopied);
    const [isCopyClicked, setIsCopyClicked] = (0, $cozmU.useState)(false);
    const handleClick = (0, $cozmU.useCallback)((e)=>{
        e.stopPropagation();
        handleCopyClick();
        setIsCopyClicked(true);
    }, [
        handleCopyClick
    ]);
    const handleMouseLeave = ()=>{
        setIsCopyClicked(false);
    };
    const displayName = ()=>{
        const author = version?.author;
        if (!author?.id) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $073a675ae869dda9$var$i18n.lastEditedByAnonymousUserLabel);
        if (author?.isActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$073a675ae869dda9$var$i18n.lastEditedByLabel,
            values: {
                author: author?.displayName
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$073a675ae869dda9$var$i18n.lastEditedByDeactivatedUserLabel,
            values: {
                author: author?.displayName
            }
        });
    };
    const shouldShowCopyIcon = isSelected && isCopyAllowed;
    const versionContainsAIContent = version.contentProperties?.latest?.versionContainsAIContent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        isSelected: isSelected,
        testId: "version-history-item",
        onClick: ()=>handleVersionClick(version)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        alignBlock: "center",
        spread: "space-between",
        xcss: $073a675ae869dda9$var$itemContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        space: "space.050"
    }, (0, $9wGTI.fg)('whiteboard-show-ai-contributor-version-history') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $073a675ae869dda9$var$styles.customStylesContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        size: "medium"
    }, (0, $ck0S9.getFormattedDate)(version.updatedTime, formatDate, formatTime))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: versionContainsAIContentTooltip
    }, versionContainsAIContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        maxWidth: 95,
        appearance: "neutral"
    }, aiContentText))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        size: "medium"
    }, (0, $ck0S9.getFormattedDate)(version.updatedTime, formatDate, formatTime), ' '), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        size: "small",
        color: "color.text.subtle"
    }, displayName())), shouldShowCopyIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: isCopyClicked ? copiedText : copyAllContentText,
        position: "bottom",
        key: isCopyClicked ? 'copied' : 'default'
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            ...tooltipProps,
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))),
            label: formatMessage($073a675ae869dda9$var$i18n.copyIconLabel),
            onClick: handleClick,
            onMouseLeave: handleMouseLeave,
            onBlur: handleMouseLeave,
            testId: "version-content-copy-button"
        }))));
};
module.exports["VersionHistoryCurrentVersionItem"] = $073a675ae869dda9$export$15c96dc1a83defb4;
module.exports["VersionHistoryItem"] = $073a675ae869dda9$export$e0ca0449ea662b5;

});

parcelRegister("8DoOG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $RfroO = parcelRequire("RfroO");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $ad7Ou = parcelRequire("ad7Ou");


var $6oFU6 = parcelRequire("6oFU6");

const $ed56899ddf7b83e5$var$i18n = (0, $kSwu1.defineMessages)({
    errorStateHeaderTitle: {
        id: "version-history.error-state.header.title",
        defaultMessage: "Unable to load"
    },
    newRetryOrRefreshText: {
        id: "version-history.error-state.new.retry.or.refresh.text",
        defaultMessage: "We were unable to load history. Try again, or check your network connection."
    },
    retryButtonText: {
        id: "version-history.error-state.retry.button.text",
        defaultMessage: "Retry"
    }
});
const $ed56899ddf7b83e5$var$errorStateContainerStyles = (0, $buxP3.xcss)({
    flexGrow: 1
});
const $ed56899ddf7b83e5$export$c1ed4f415b9e7023 = ({ refetch: refetch })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleRefetch = (0, $cozmU.useCallback)(()=>{
        refetch();
    }, [
        refetch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $ed56899ddf7b83e5$var$errorStateContainerStyles,
        paddingInline: "space.600",
        paddingBlockEnd: "space.600",
        testId: "version-error-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $RfroO.default), {
        header: formatMessage($ed56899ddf7b83e5$var$i18n.errorStateHeaderTitle),
        description: formatMessage($ed56899ddf7b83e5$var$i18n.newRetryOrRefreshText),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleRefetch
        }, formatMessage($ed56899ddf7b83e5$var$i18n.retryButtonText)),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6oFU6)))
    }));
};
module.exports["ErrorState"] = $ed56899ddf7b83e5$export$c1ed4f415b9e7023;

});

parcelRegister("6oFU6", function(module, exports) {
module.exports = new URL("GenericErrorImage.b96ea332.svg", import.meta.url).toString();

});

parcelRegister("kI68q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $kA6Zo = parcelRequire("kA6Zo");


var $2wCqQ = parcelRequire("2wCqQ");


var $3hnrC = parcelRequire("3hnrC");

var $4WZFP = parcelRequire("4WZFP");

const $7a46560dab52d7e2$var$titleSkeleton = (0, $buxP3.xcss)({
    height: '16px',
    width: '100%',
    borderRadius: 'radius.full'
});
const $7a46560dab52d7e2$var$subHeaderSkeletion = (0, $buxP3.xcss)({
    height: '14px',
    borderRadius: 'radius.full',
    width: '60px',
    marginBottom: 'space.150'
});
const $7a46560dab52d7e2$var$versionItemSkeleton = (0, $buxP3.xcss)({
    width: '75%',
    borderRadius: 'radius.full'
});
const $7a46560dab52d7e2$var$sectionBodySkeleton = (0, $buxP3.xcss)({
    width: '100%',
    paddingBlock: 'space.250'
});
const $7a46560dab52d7e2$export$ad13dd24f966ba14 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        "data-testId": "version-history-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4WZFP.SidePanelHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $7a46560dab52d7e2$var$titleSkeleton,
        backgroundColor: "color.skeleton"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3hnrC.SidePanelBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        xcss: $7a46560dab52d7e2$var$sectionBodySkeleton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $7a46560dab52d7e2$var$subHeaderSkeletion,
        paddingBlock: "space.100",
        paddingInline: "space.200",
        backgroundColor: "color.skeleton"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $7a46560dab52d7e2$var$versionItemSkeleton,
        paddingBlock: "space.100",
        backgroundColor: "color.skeleton"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        xcss: $7a46560dab52d7e2$var$sectionBodySkeleton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $7a46560dab52d7e2$var$subHeaderSkeletion,
        paddingBlock: "space.100",
        paddingInline: "space.200",
        backgroundColor: "color.skeleton"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $7a46560dab52d7e2$var$versionItemSkeleton,
        paddingBlock: "space.100",
        paddingInline: "space.200",
        backgroundColor: "color.skeleton"
    }))));
};
module.exports["VersionHistoryLoadingPlaceholder"] = $7a46560dab52d7e2$export$ad13dd24f966ba14;

});

parcelRegister("lUzNY", function(module, exports) {

var $ajKhM = parcelRequire("ajKhM");

const $abbf907a8bf3bb4c$export$86e1b013192cc9f6 = new (0, $ajKhM.ContentTypesActionsService)();
module.exports["contentMoreActionsService"] = $abbf907a8bf3bb4c$export$86e1b013192cc9f6;

});

parcelRegister("ajKhM", function(module, exports) {
class $c2d4c8ee0dd05cbe$export$abca6ba7b5fccda8 {
    dispose() {
        this.handlers.clear();
    }
    updateActions(data) {
        this.handlers.forEach((handler)=>handler(data));
    }
    onActionsUpdate(cb) {
        this.handlers.add(cb);
        return ()=>{
            this.handlers.delete(cb);
        };
    }
    constructor(){
        this.handlers = new Set();
    }
}
module.exports["ContentTypesActionsService"] = $c2d4c8ee0dd05cbe$export$abca6ba7b5fccda8;

});

parcelRegister("3r60T", function(module, exports) {
class $1f097128e34aca92$export$8bb2aafdd7e4ca0b {
    dispose() {
        this.changeObjectSidebarShownHandler = [];
        this.changeObjectSidebarShownHandler_LEGACY = [];
    }
    registerChangeObjectSidebarShownHandler(callback) {
        this.changeObjectSidebarShownHandler.push(callback);
    }
    registerChangeObjectSidebarShownHandler_LEGACY(callback) {
        this.changeObjectSidebarShownHandler_LEGACY.push(callback);
    }
    onChangeObjectSidebarShown(state) {
        this.changeObjectSidebarShownHandler.forEach((callback)=>callback(state));
    }
    onChangeObjectSidebarShown_LEGACY(isShown) {
        this.changeObjectSidebarShownHandler_LEGACY.forEach((callback)=>callback(isShown));
    }
    constructor(){
        this.changeObjectSidebarShownHandler = void 0;
        this.changeObjectSidebarShownHandler_LEGACY = void 0;
        this.changeObjectSidebarShownHandler = [];
        this.changeObjectSidebarShownHandler_LEGACY = [];
    }
}
module.exports["ContentTypesObjectSidebarService"] = $1f097128e34aca92$export$8bb2aafdd7e4ca0b;

});

parcelRegister("exahZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $6hmtW = parcelRequire("6hmtW");


var $9FoVw = parcelRequire("9FoVw");


var $9wGTI = parcelRequire("9wGTI");


var $fHAwL = parcelRequire("fHAwL");

const $f159370a32aca251$export$9008442889802bb3 = ()=>{
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel, hideCommentsPanel: hideCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCurrentView: setCurrentView } = (0, $3mVfX.useCommentsPanelActions)();
    const { currentView: currentView } = (0, $3mVfX.useCommentsPanelState)();
    const { updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    const setCommentThreadHandler = (0, $cozmU.useCallback)((threadId)=>{
        // highlight a comment in sidebar
        // if threadId is undefined, it means we are de-selecting
        setCurrentlySelectedThreadKey(threadId);
        if (threadId) {
            // Use unified navigation - content-types-bridge-comments only has inline comments
            let expectedView = undefined;
            if (currentView === (0, $3mVfX.ViewValues).RESOLVED) {
                expectedView = (0, $3mVfX.ViewValues).OPEN;
                setCurrentView && setCurrentView((0, $3mVfX.ViewValues).OPEN);
            }
            (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                context: (0, $9FoVw.NavigationContext).PANEL,
                block: 'center',
                annotationId: threadId,
                commentType: 'INLINE',
                annotationClicked: true,
                expectedView: expectedView
            });
        }
    }, [
        setCurrentlySelectedThreadKey,
        currentView,
        setCurrentView
    ]);
    const triggerReadStatusCommentHandler = (0, $cozmU.useCallback)((commentIds, read = false)=>{
        if ((0, $9wGTI.fg)('cc-whiteboards-consolidating-comments-unread')) {
            if (read) updateUnreadCommentIDSet(new Set(commentIds), 'remove');
        }
    }, [
        updateUnreadCommentIDSet
    ]);
    const showPanelHandler = (0, $cozmU.useCallback)((threadId)=>{
        if (!isCommentsPanelShown) showCommentsPanel();
        if (threadId) setCommentThreadHandler(threadId);
        // triggerCommentPanelRefresh handles the case where the view hasn't mounted yet
        // by setting a pending flag that fires once the handler is registered.
        commentService.triggerCommentPanelRefresh();
    }, [
        isCommentsPanelShown,
        showCommentsPanel,
        setCommentThreadHandler,
        commentService
    ]);
    const hidePanelHandler = (0, $cozmU.useCallback)(()=>{
        if (isCommentsPanelShown) hideCommentsPanel();
    }, [
        isCommentsPanelShown,
        hideCommentsPanel
    ]);
    (0, $cozmU.useEffect)(()=>{
        commentService.registerSelectCommentThreadHandler(setCommentThreadHandler);
        commentService.registerShowPanelHandler(showPanelHandler);
        commentService.registerHidePanelHandler(hidePanelHandler);
        commentService.registerTriggerReadStatusComment(triggerReadStatusCommentHandler);
        return ()=>{
            // un-set the handlers on component unmount
            commentService.registerSelectCommentThreadHandler(undefined);
            commentService.registerShowPanelHandler(undefined);
            commentService.registerHidePanelHandler(undefined);
            commentService.registerTriggerReadStatusComment(undefined);
        };
    }, [
        commentService,
        showPanelHandler,
        hidePanelHandler,
        setCommentThreadHandler,
        triggerReadStatusCommentHandler
    ]);
};
module.exports["useRegisterCommentsPanelCallbacks"] = $f159370a32aca251$export$9008442889802bb3;

});

parcelRegister("8Nvuv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $eexeE = parcelRequire("eexeE");


var $pD8NN = parcelRequire("pD8NN");

const $1d6be43f8f66df53$var$EnabledCanvasFlagToShareRegistrar = ({ bridge: bridge, contentId: contentId, type: type })=>{
    const { shouldCollectProgress: shouldCollectProgress, notifyProgress: notifyProgress } = (0, $eexeE.useCanvasFlagToShare)({
        contentId: contentId,
        type: type
    });
    (0, $pD8NN.useRegisterShareCriteriaProgress)({
        bridge: bridge,
        shouldCollectProgress: shouldCollectProgress,
        notifyProgress: notifyProgress
    });
    return null;
};
const $1d6be43f8f66df53$export$3c974376c524b2a3 = (props)=>{
    if (props.type === 'slides' || !(0, $9wGTI.fg)('twcg-2055-confluence-onboarding-flag-to-share-fg')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1d6be43f8f66df53$var$EnabledCanvasFlagToShareRegistrar, props);
};
module.exports["CanvasFlagToShareRegistrar"] = $1d6be43f8f66df53$export$3c974376c524b2a3;

});

parcelRegister("eexeE", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ilwm5 = parcelRequire("ilwm5");


var $eU2ry = parcelRequire("eU2ry");

const $f450112dc8ec0092$var$getCanvasProgressDelta = (progress, baseline)=>{
    if (progress.type === 'whiteboard') return {
        type: 'whiteboard',
        elements: baseline.type === 'whiteboard' ? Math.max(progress.elements - baseline.elements, 0) : 0
    };
    return {
        type: 'database',
        rows: baseline.type === 'database' ? Math.max(progress.rows - baseline.rows, 0) : 0,
        columns: baseline.type === 'database' ? Math.max(progress.columns - baseline.columns, 0) : 0,
        filledCells: baseline.type === 'database' ? Math.max(progress.filledCells - baseline.filledCells, 0) : 0
    };
};
function $f450112dc8ec0092$export$2fe447c89b437f02(t0) {
    const $ = (0, $bDgLe.c)(19);
    const { type: type, contentId: contentId } = t0;
    let t1;
    if ($[0] !== contentId || $[1] !== type) {
        t1 = {
            type: type,
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = type;
        $[2] = t1;
    } else t1 = $[2];
    const { shouldCollectProgress: shouldCollectProgress, notifyProgress: notifyNormalizedProgress } = (0, $eU2ry.useFlagToShare)(t1);
    let t2;
    if ($[3] !== contentId || $[4] !== type) {
        t2 = {
            contentId: contentId,
            type: type
        };
        $[3] = contentId;
        $[4] = type;
        $[5] = t2;
    } else t2 = $[5];
    const session = t2;
    const activeBaselineRef = (0, $cozmU.useRef)(null);
    const latestNotifierRef = (0, $cozmU.useRef)(notifyNormalizedProgress);
    const activeSessionRef = (0, $cozmU.useRef)(null);
    let t3;
    let t4;
    if ($[6] !== session) {
        t3 = ()=>{
            activeBaselineRef.current = null;
            activeSessionRef.current = session;
            return ()=>{
                if (activeSessionRef.current === session) activeSessionRef.current = null;
            };
        };
        t4 = [
            session
        ];
        $[6] = session;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useLayoutEffect)(t3, t4);
    let t5;
    let t6;
    if ($[9] !== notifyNormalizedProgress) {
        t5 = ()=>{
            latestNotifierRef.current = notifyNormalizedProgress;
        };
        t6 = [
            notifyNormalizedProgress
        ];
        $[9] = notifyNormalizedProgress;
        $[10] = t5;
        $[11] = t6;
    } else {
        t5 = $[10];
        t6 = $[11];
    }
    (0, $cozmU.useLayoutEffect)(t5, t6);
    let t7;
    if ($[12] !== contentId || $[13] !== session || $[14] !== type) {
        t7 = (progress)=>{
            if (activeSessionRef.current !== session) return;
            if (!(0, $ilwm5.isShareProgressForType)(type, progress)) {
                latestNotifierRef.current(progress);
                return;
            }
            const activeBaseline = activeBaselineRef.current;
            if (!activeBaseline || activeBaseline.contentId !== contentId || activeBaseline.type !== type) {
                activeBaselineRef.current = {
                    contentId: contentId,
                    type: type,
                    progress: progress
                };
                latestNotifierRef.current($f450112dc8ec0092$var$getCanvasProgressDelta(progress, progress));
                return;
            }
            latestNotifierRef.current($f450112dc8ec0092$var$getCanvasProgressDelta(progress, activeBaseline.progress));
        };
        $[12] = contentId;
        $[13] = session;
        $[14] = type;
        $[15] = t7;
    } else t7 = $[15];
    const notifyProgress = t7;
    let t8;
    if ($[16] !== notifyProgress || $[17] !== shouldCollectProgress) {
        t8 = {
            shouldCollectProgress: shouldCollectProgress,
            notifyProgress: notifyProgress
        };
        $[16] = notifyProgress;
        $[17] = shouldCollectProgress;
        $[18] = t8;
    } else t8 = $[18];
    return t8;
}
module.exports["useCanvasFlagToShare"] = $f450112dc8ec0092$export$2fe447c89b437f02;

});

parcelRegister("pD8NN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6f4f37727e39af88$export$f00c0be7b3dbd0f6 = ({ bridge: bridge, shouldCollectProgress: shouldCollectProgress, notifyProgress: notifyProgress })=>{
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!shouldCollectProgress || !bridge.confluenceAPI) return;
        const onboarding = bridge.confluenceAPI.onboarding ?? {};
        bridge.confluenceAPI.onboarding = onboarding;
        onboarding.notifyShareCriteriaProgress = notifyProgress;
        return ()=>{
            if (onboarding.notifyShareCriteriaProgress === notifyProgress) delete onboarding.notifyShareCriteriaProgress;
        };
    }, [
        bridge,
        notifyProgress,
        shouldCollectProgress
    ]);
};
module.exports["useRegisterShareCriteriaProgress"] = $6f4f37727e39af88$export$f00c0be7b3dbd0f6;

});

parcelRegister("ckYtV", function(module, exports) {

var $ajKhM = parcelRequire("ajKhM");

const $98c75de9c6816705$export$b14be44a1e8054b7 = new (0, $ajKhM.ContentTypesActionsService)();
module.exports["contentMainActionsService"] = $98c75de9c6816705$export$b14be44a1e8054b7;

});

parcelRegister("hzClJ", function(module, exports) {

var $ajKhM = parcelRequire("ajKhM");

const $45deabb561664896$export$3cfba92d89128616 = new (0, $ajKhM.ContentTypesActionsService)();
module.exports["contentCollaboratorsService"] = $45deabb561664896$export$3cfba92d89128616;

});

parcelRegister("j96gu", function(module, exports) {

var $ajKhM = parcelRequire("ajKhM");

const $a9fb895ec6d62898$export$f5a70a5466fbb969 = new (0, $ajKhM.ContentTypesActionsService)();
module.exports["contentBoardStatusService"] = $a9fb895ec6d62898$export$f5a70a5466fbb969;

});

parcelRegister("6attE", function(module, exports) {
/* eslint-disable @atlassian/perf-linting/no-chain-state-updates */ 
var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $bQm3c = parcelRequire("bQm3c");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $6S5EB = parcelRequire("6S5EB");


var $6fil2 = parcelRequire("6fil2");


var $7mpOv = parcelRequire("7mpOv");


var $P7iy7 = parcelRequire("P7iy7");

const $98eb6766d8546971$export$403c2a860d415c5b = ({ tenantId: tenantId, space: space, referenceId: referenceId, contentId: contentId, shareToken: shareToken, dataSecurityPolicyPageExport: dataSecurityPolicyPageExport, dataSecurityPolicyAttachmentDownload: dataSecurityPolicyAttachmentDownload, refetch: refetch, documentType: documentType = 'whiteboard', onPermissionChange: onPermissionChange })=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const [tokenService] = (0, $cozmU.useState)(()=>new (0, $P7iy7.WhiteboardTokenService)(documentType));
    const isExternal = (0, $6S5EB.isExternalShareRequest)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    (0, $cozmU.useEffect)(()=>{
        tokenService.onInvalidToken(()=>{
            refetch?.();
        });
        tokenService.onTokenChange((token)=>{
            if (onPermissionChange) {
                const permissions = tokenService.getPermissions(token);
                onPermissionChange(permissions);
            }
        });
        tokenService.onTokenLoadError((error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) refetch?.();
            else if ((0, $6fil2.containsNetworkError)(error)) experienceTracker.abort({
                name: (0, $irVI7.WHITEBOARD_EXPERIENCE),
                reason: 'Network error while fetching token'
            });
            else if ((0, $f9jv7.isNotFoundError)(error)) experienceTracker.abort({
                name: (0, $irVI7.WHITEBOARD_EXPERIENCE),
                reason: 'Requested content not found while fetching token'
            });
            else if (tokenService.hasMissingTokenData(error.message)) experienceTracker.abort({
                name: (0, $irVI7.WHITEBOARD_EXPERIENCE),
                reason: 'Missing token data while fetching token'
            });
            else experienceTracker.fail({
                name: (0, $irVI7.WHITEBOARD_EXPERIENCE),
                error: error
            });
        });
    }, [
        tokenService,
        refetch,
        experienceTracker,
        onPermissionChange
    ]);
    // Update the current token whenever the space or contentId changes
    (0, $cozmU.useEffect)(()=>{
        if (!space.id) return;
        tokenService.setContext({
            spaceId: space.id,
            tenantId: tenantId,
            contentId: contentId,
            confluenceEdition: edition || '',
            isExternal: isExternal,
            shareToken: shareToken,
            dataSecurityPolicyPageExport: dataSecurityPolicyPageExport,
            dataSecurityPolicyAttachmentDownload: dataSecurityPolicyAttachmentDownload,
            isAIEnabledForContent: isAIEnabledForContent,
            isRovoEnabledForContent: isRovoEnabledForContent
        });
        // For databases, always fetch token (can use contentId when referenceId is missing)
        // For whiteboards, only fetch when referenceId is available
        if (referenceId || documentType === 'database') tokenService.updateToken(referenceId ?? undefined).catch(()=>{
        // handled by the `onTokenLoadError` function defined in the useEffect above this
        });
        return ()=>tokenService.resetToken();
    }, [
        tokenService,
        tenantId,
        space.id,
        referenceId,
        contentId,
        edition,
        shareToken,
        isExternal,
        dataSecurityPolicyPageExport,
        dataSecurityPolicyAttachmentDownload,
        isAIEnabledForContent,
        isRovoEnabledForContent,
        documentType
    ]);
    return tokenService;
};
module.exports["useTokenService"] = $98eb6766d8546971$export$403c2a860d415c5b;

});

parcelRegister("P7iy7", function(module, exports) {

var $6AroL = parcelRequire("6AroL");


var $5OelY = parcelRequire("5OelY");


var $bNTw9 = parcelRequire("bNTw9");


var $g5Qvc = parcelRequire("g5Qvc");


var $hlYjz = parcelRequire("hlYjz");


var $1AV5C = parcelRequire("1AV5C");


var $9wGTI = parcelRequire("9wGTI");


var $j5j6W = parcelRequire("j5j6W");


var $i9cO2 = parcelRequire("i9cO2");


var $c0rhi = parcelRequire("c0rhi");

const $836053ad975c4b64$var$emptyContext = ()=>({
        spaceId: '',
        tenantId: '',
        contentId: '',
        confluenceEdition: '',
        isExternal: false,
        shareToken: '',
        dataSecurityPolicyPageExport: null,
        dataSecurityPolicyAttachmentDownload: null,
        isAIEnabledForContent: false,
        isRovoEnabledForContent: false
    });
/**
 * Used to refer to the 'home' view.
 */ const $836053ad975c4b64$var$FALLBACK_HOME_KEY = 'root';
/**
 * Used to refer to the 'create' view.
 */ const $836053ad975c4b64$var$FALLBACK_CREATE_KEY = 'create';
/**
 * Set to a value a little below the server timeout to account for networking delays and retries.
 */ const $836053ad975c4b64$var$EXPIRY_TIME_MILLSECONDS = 540000;
/**
 * Note: This is currently a module scope value as we recreate the token service on SPA transitions. This would cause us to fetch cached tokens on the first transition to a board which would result in a token expiry errors.
 * @see {@link https://atlassian.slack.com/archives/C027MLUFSFN/p1717038827909519?thread_ts=1716372417.294799&cid=C027MLUFSFN}
 */ let $836053ad975c4b64$var$isFirstLoad = true;
const $836053ad975c4b64$var$allowedDocumentTypes = [
    'whiteboard',
    'slide',
    'database'
];
const $836053ad975c4b64$var$isCanvasAccessAri = (ari)=>ari.startsWith('ari:cloud:canvas:');
class $836053ad975c4b64$export$b957651e6c38f607 {
    dispose() {
        this.handlers = [];
        this.context = $836053ad975c4b64$var$emptyContext();
        this.token = undefined;
        this.cache = new Map();
    }
    /**
   * Sets the context of the token service.
   * @description Used to fetch tokens pinned to space & site.
   */ setContext({ spaceId: spaceId, tenantId: tenantId, contentId: contentId, confluenceEdition: confluenceEdition, isExternal: isExternal, shareToken: shareToken, dataSecurityPolicyPageExport: dataSecurityPolicyPageExport, dataSecurityPolicyAttachmentDownload: dataSecurityPolicyAttachmentDownload, isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent }) {
        this.context.spaceId = spaceId;
        this.context.tenantId = tenantId;
        this.context.contentId = contentId;
        this.context.confluenceEdition = confluenceEdition;
        this.context.isExternal = isExternal;
        this.context.shareToken = shareToken;
        this.context.dataSecurityPolicyPageExport = dataSecurityPolicyPageExport;
        this.context.dataSecurityPolicyAttachmentDownload = dataSecurityPolicyAttachmentDownload;
        this.context.isAIEnabledForContent = isAIEnabledForContent;
        this.context.isRovoEnabledForContent = isRovoEnabledForContent;
    }
    /**
   * @description Method for taking an encoded access token and determining whether or
   * not it has read permissions for the document
   * @returns boolean value indicating whether the provided token has sufficient
   * document permissions or not
   */ isValidToken(token, key) {
        if (token?.accessToken) {
            /**
       * If on home or create routes, existence of a token is enough to ensure
       * the user has permission to take the provided action (view home or create).
       */ if (key === $836053ad975c4b64$var$FALLBACK_HOME_KEY) return true;
            if (key === $836053ad975c4b64$var$FALLBACK_CREATE_KEY) return true;
            const decodedAccessToken = (0, $6AroL.default)(token.accessToken);
            const documentARI = Object.keys(decodedAccessToken.access).find($836053ad975c4b64$var$isCanvasAccessAri);
            if (documentARI) {
                const documentAccess = decodedAccessToken.access[documentARI];
                if (documentAccess && documentAccess.includes('read')) return true;
            }
        }
        return false;
    }
    /**
   * @description Method for taking an encoded access token and returning the permissions
   * @returns an empty array if no claims exist. An array with [read] for read only or [read, write] if editable
   */ getPermissions(token) {
        if (token?.accessToken) {
            const decodedAccessToken = (0, $6AroL.default)(token.accessToken);
            const documentARI = Object.keys(decodedAccessToken.access).find($836053ad975c4b64$var$isCanvasAccessAri);
            if (documentARI) return decodedAccessToken.access[documentARI];
        }
        return [];
    }
    /**
   * Loads a token by reaching out to a specific token URL.
   * @param referenceId
   */ async loadToken(referenceId) {
        // We cannot fetch a token without a context.
        // Hence, we default to 'empty'.
        if (!this.hasContext()) return undefined;
        const handleError = (err)=>{
            this.tokenErrorHandler(err);
            return undefined;
        };
        const { spaceId: spaceId, tenantId: tenantId, contentId: contentId, shareToken: shareToken, isExternal: isExternal, dataSecurityPolicyPageExport: dataSecurityPolicyPageExport, dataSecurityPolicyAttachmentDownload: dataSecurityPolicyAttachmentDownload, isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = this.context;
        try {
            const tokenPromise = isExternal && shareToken ? await $836053ad975c4b64$var$fetchExternalTokenDataByGraphQL(shareToken) : await $836053ad975c4b64$var$fetchTokenDataByGraphQL(contentId, $836053ad975c4b64$var$isFirstLoad);
            $836053ad975c4b64$var$isFirstLoad = false;
            const { accessToken: accessToken, mediaToken: mediaToken, mediaBaseUrl: mediaBaseUrl, whiteboardEntitlements: whiteboardEntitlements } = tokenPromise;
            if (!accessToken || !mediaToken || !mediaBaseUrl) {
                const missingItems = [
                    ...!accessToken ? [
                        'accessToken'
                    ] : [],
                    ...!mediaToken ? [
                        'mediaToken'
                    ] : [],
                    ...!mediaBaseUrl ? [
                        'mediaBaseUrl'
                    ] : []
                ];
                const missingTokenError = new Error(`missing token data for: ${missingItems.join(', ')}`);
                return handleError(missingTokenError);
            }
            const containerAri = (0, $5OelY.ConfluenceSpaceAri).create({
                siteId: tenantId,
                spaceId: spaceId
            });
            const boardAri = referenceId ? this.getBoardAri(referenceId, tenantId) : '';
            const features = {
                whiteboards: {
                    ...whiteboardEntitlements.whiteboards,
                    aiGenerate: {
                        isEntitled: isAIEnabledForContent
                    },
                    aiClustering: {
                        isEntitled: isAIEnabledForContent
                    },
                    aiTeammate: {
                        isEntitled: isAIEnabledForContent && isRovoEnabledForContent
                    },
                    aiSmartButton: {
                        isEntitled: isAIEnabledForContent && isRovoEnabledForContent
                    },
                    aiJiraSearch: {
                        isEntitled: isAIEnabledForContent
                    },
                    jiraIssueUnfurl: {
                        isEntitled: whiteboardEntitlements.whiteboards?.smartConnectors?.isEntitled ?? false
                    }
                }
            };
            const dataSecurityPolicy = {
                pageExport: dataSecurityPolicyPageExport === true,
                attachmentDownload: (0, $9wGTI.fg)('cc-dlp_split-attachment-dl-from-export-dsp') ? dataSecurityPolicyAttachmentDownload === true : dataSecurityPolicyPageExport === true
            };
            const policies = {
                policies: {
                    dataSecurityPolicy: dataSecurityPolicy
                }
            };
            return {
                container: containerAri.toString(),
                board: boardAri.toString(),
                accessToken: accessToken,
                mediaToken: mediaToken,
                mediaBaseUrl: mediaBaseUrl,
                mediaCollectionId: contentId,
                features: features,
                edition: this.context.confluenceEdition,
                ...policies
            };
        } catch (err) {
            return handleError(err);
        }
    }
    /**
   * Checks if there is enough data in {@link context} to fetch a token.
   */ hasContext() {
        const hasTenantId = this.context.tenantId.length > 0;
        const hasSpaceId = this.context.spaceId.length > 0;
        const hasContentId = this.context.contentId.length > 0;
        const hasConfluenceEdition = Boolean(this.context.confluenceEdition);
        return hasTenantId && hasSpaceId && hasContentId && hasConfluenceEdition;
    }
    /**
   * Checks if the {@link token} has expected data in it.
   */ hasToken(token) {
        return Boolean(token && token.accessToken && token.container);
    }
    constructor(documentType){
        this.documentType = void 0;
        this.handlers = void 0;
        this.context = void 0;
        this.token = void 0;
        this.cache = void 0;
        this.invalidTokenHandler = void 0;
        // @ts-ignore
        this.tokenErrorHandler = void 0;
        /**
     * A method called on every route transition on whiteboards.
     * @returns <void> Sets a fresh token with encoded permissions.
     */ this.updateToken = async (referenceId)=>{
            const token = await this.preloadToken(referenceId);
            this.token = token;
            this.handlers.forEach((handler)=>handler(token));
        };
        /**
     * A method called on every route transition on whiteboards to empty the existing token.
     * @returns <void> Sets an empty token with encoded permissions.
     */ this.resetToken = ()=>{
            this.token = undefined;
            this.context = $836053ad975c4b64$var$emptyContext();
            this.handlers.forEach((handler)=>handler(undefined));
        };
        /**
     * Setup listeners for token changes.
     * @description Called everytime the token updates.
     */ this.onTokenChange = (cb)=>{
            this.handlers.push(cb);
        };
        /**
     * Setup listener for invalid token
     * @description Called within preloadToken if the token is lacking sufficient whiteboard permissions.
     */ this.onInvalidToken = (cb)=>{
            this.invalidTokenHandler = cb;
        };
        /**
     * Setup listener for a token error
     * @description Called within loadToken's catch in case there is an error loading the token
     */ // @ts-ignore
        this.onTokenLoadError = (cb)=>{
            this.tokenErrorHandler = cb;
        };
        /**
     * Checks if the error message indicates that token data is missing.
     * @description Used to determine if the experience should be aborted due to missing token data.
     * @returns boolean indicating whether the error message contains 'missing token data'.
     */ this.hasMissingTokenData = (message)=>{
            if (message.includes('missing token data')) // Missing accessToken, mediaToken, or mediaBaseUrl necessary for whiteboards to function
            return true;
            return false;
        };
        /**
     * Setup listeners for token initialisation.
     * @description Called once at the start of the lifetime of the whiteboard frame.
     */ this.onTokenInit = (cb)=>{
            cb(this.token);
        };
        this.getHashKey = (id)=>{
            return (0, $1AV5C.hashData)(JSON.stringify({
                id: id,
                ...this.context
            }));
        };
        /**
     * Starts preloading a token, and stores the result in {@link cache}.
     * @description Implements a mutex by keeping one promise per content id.
     */ this.preloadToken = (id)=>{
            const key = id ? this.getHashKey(id) : $836053ad975c4b64$var$FALLBACK_HOME_KEY;
            const entry = this.cache.get(key);
            const now = Date.now();
            const fetching = entry?.promise;
            const resolved = entry?.resolved;
            const expired = Boolean(entry?.expiresAt && now >= entry.expiresAt);
            if (fetching) {
                if (!resolved) return fetching;
                if (!expired) return fetching;
                else this.cache.delete(key);
            }
            const promise = this.loadToken(id);
            this.cache.set(key, {
                promise: promise,
                resolved: false
            });
            promise.then((token)=>{
                // Do not hold onto empty tokens
                if (!this.hasToken(token)) {
                    this.cache.delete(key);
                    return;
                }
                if (!this.isValidToken(token, key)) {
                    this.cache.delete(key);
                    this.invalidTokenHandler();
                    return;
                }
                this.cache.set(key, {
                    promise: promise,
                    resolved: true,
                    expiresAt: now + $836053ad975c4b64$var$EXPIRY_TIME_MILLSECONDS
                });
            }).catch((_err)=>{
                // Do not hold onto tokens which failed to be fetched
                this.cache.delete(key);
            });
            return promise;
        };
        /**
     * Gives the consumer the existing token for a route, or starts fetching one.
     * @description Uses the same mutex implemented in {@link preloadToken}
     */ this.getToken = (id)=>{
            return this.preloadToken(id);
        };
        /**
     * A method for forcing refresh of a token.
     * @description Used when permissions change on a whiteboard, forcing users
     * to refetch a new token.
     * @description Delegates to {@link revokeToken} to revoke the current token.
     * @returns <void>
     */ this.refreshToken = async (id)=>{
            this.revokeToken(id);
            await this.updateToken(id);
        };
        /**
     * A method for revoking a token.
     * @description Used when permissions change on a whiteboard, forcing users
     * to refetch a new token.
     * @returns <void>
     */ this.revokeToken = (id)=>{
            const key = id ? this.getHashKey(id) : $836053ad975c4b64$var$FALLBACK_HOME_KEY;
            this.token = undefined;
            this.cache.delete(key);
            this.handlers.forEach((handler)=>handler(undefined));
        };
        /**
     * A method for getting the board ari.
     * @description Used to determine the board ari for a given reference id and document type.
     * @param referenceId
     * @param tenantId
     * @private
     */ this.getBoardAri = (referenceId, tenantId)=>{
            switch(this.documentType){
                case 'database':
                    return (0, $g5Qvc.CanvasDatabaseAri).create({
                        siteId: tenantId,
                        databaseId: referenceId
                    });
                case 'slide':
                    return (0, $hlYjz.CanvasSlideAri).create({
                        siteId: tenantId,
                        slideId: referenceId
                    });
                default:
                    return (0, $bNTw9.CanvasBoardAri).create({
                        siteId: tenantId,
                        boardId: referenceId
                    });
            }
        };
        this.documentType = documentType;
        this.handlers = [];
        this.context = $836053ad975c4b64$var$emptyContext();
        this.token = undefined;
        this.cache = new Map();
        this.invalidTokenHandler = ()=>{};
        this.tokenErrorHandler = ()=>{};
    }
}
const $836053ad975c4b64$var$fetchTokenDataByGraphQL = async (contentId, useCache = false)=>{
    const tokenQuery = await (0, $c0rhi.queryInterop)({
        query: (0, $j5j6W.WhiteboardTokenQuery),
        variables: {
            contentId: contentId
        },
        context: {
            fetchOptions: {
                ignoreNoNetworkError: true
            }
        },
        fetchPolicy: useCache ? 'cache-first' : 'no-cache',
        __callerPackage__: "whiteboard-common"
    });
    const accessToken = tokenQuery?.data?.canvasToken?.token;
    const readOnlyMediaToken = tokenQuery?.data?.contentMediaSession?.accessTokens?.readOnlyToken?.value;
    const readWriteMediaToken = tokenQuery?.data?.contentMediaSession?.accessTokens?.readWriteToken?.value;
    const mediaBaseUrl = tokenQuery?.data?.contentMediaSession?.configuration?.fileStoreUrl;
    const whiteboardEntitlements = tokenQuery?.data?.entitlements?.whiteboardFeatures;
    return {
        accessToken: accessToken,
        mediaToken: readWriteMediaToken || readOnlyMediaToken,
        mediaBaseUrl: mediaBaseUrl,
        whiteboardEntitlements: {
            whiteboards: whiteboardEntitlements
        }
    };
};
const $836053ad975c4b64$var$fetchExternalTokenDataByGraphQL = async (shareToken)=>{
    const tokenQuery = await (0, $c0rhi.queryInterop)({
        query: (0, $i9cO2.ExternalWhiteboardTokenQuery),
        variables: {
            shareToken: shareToken
        },
        context: {
            allowOnExternalPage: true,
            fetchOptions: {
                ignoreNoNetworkError: true
            }
        },
        fetchPolicy: 'no-cache',
        __callerPackage__: "whiteboard-common"
    });
    const data = tokenQuery?.data;
    const accessToken = data?.externalCanvasToken?.token;
    const readOnlyMediaToken = data?.externalContentMediaSession?.accessTokens?.readOnlyToken?.value;
    const readWriteMediaToken = data?.externalContentMediaSession?.accessTokens?.readWriteToken?.value;
    const mediaBaseUrl = tokenQuery?.data?.externalContentMediaSession?.configuration?.fileStoreUrl;
    const whiteboardEntitlements = data?.entitlements?.whiteboardFeatures;
    return {
        accessToken: accessToken,
        mediaToken: readWriteMediaToken || readOnlyMediaToken,
        mediaBaseUrl: mediaBaseUrl,
        whiteboardEntitlements: {
            whiteboards: whiteboardEntitlements
        }
    };
};
module.exports["WhiteboardTokenService"] = $836053ad975c4b64$export$b957651e6c38f607;

});

parcelRegister("bNTw9", function(module, exports) {

var $jwfqO = parcelRequire("jwfqO");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/canvas/board/manifest.ts
var $897f55f2452e4b1c$var$canvasBoardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jwfqO.CanvasBoardAriResourceOwner),
    resourceType: (0, $jwfqO.CanvasBoardAriResourceType),
    resourceIdSlug: "{boardId}",
    resourceIdSegmentFormats: {
        boardId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/canvas/board/index.ts
var $897f55f2452e4b1c$export$4207164a16ce22a0 = class _CanvasBoardAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get boardId() {
        return this._boardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $897f55f2452e4b1c$var$canvasBoardAriStaticOpts.qualifier,
            platformQualifier: $897f55f2452e4b1c$var$canvasBoardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $897f55f2452e4b1c$var$canvasBoardAriStaticOpts.resourceOwner,
            resourceType: $897f55f2452e4b1c$var$canvasBoardAriStaticOpts.resourceType,
            resourceId: `${opts.boardId}`,
            resourceIdSegmentValues: {
                boardId: opts.boardId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $897f55f2452e4b1c$var$canvasBoardAriStaticOpts);
        return new _CanvasBoardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $897f55f2452e4b1c$var$canvasBoardAriStaticOpts);
        return new _CanvasBoardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            boardId: this.boardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._boardId = opts.resourceIdSegmentValues.boardId;
    }
};
module.exports["CanvasBoardAri"] = $897f55f2452e4b1c$export$4207164a16ce22a0;

});

parcelRegister("jwfqO", function(module, exports) {
// src/canvas/board/types.ts
var $e35cf9d6671092b8$export$1739c82bfccbe497 = "canvas", $e35cf9d6671092b8$export$94992737b5e17ca5 = "board";
module.exports["CanvasBoardAriResourceOwner"] = $e35cf9d6671092b8$export$1739c82bfccbe497;
module.exports["CanvasBoardAriResourceType"] = $e35cf9d6671092b8$export$94992737b5e17ca5;

});

parcelRegister("g5Qvc", function(module, exports) {

var $9vfKf = parcelRequire("9vfKf");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/canvas/database/manifest.ts
var $bb75d6ce3a111b60$var$canvasDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $9vfKf.CanvasDatabaseAriResourceOwner),
    resourceType: (0, $9vfKf.CanvasDatabaseAriResourceType),
    resourceIdSlug: "{databaseId}",
    resourceIdSegmentFormats: {
        databaseId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/canvas/database/index.ts
var $bb75d6ce3a111b60$export$b5af0e69d7a83a9e = class _CanvasDatabaseAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $bb75d6ce3a111b60$var$canvasDatabaseAriStaticOpts.qualifier,
            platformQualifier: $bb75d6ce3a111b60$var$canvasDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $bb75d6ce3a111b60$var$canvasDatabaseAriStaticOpts.resourceOwner,
            resourceType: $bb75d6ce3a111b60$var$canvasDatabaseAriStaticOpts.resourceType,
            resourceId: `${opts.databaseId}`,
            resourceIdSegmentValues: {
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $bb75d6ce3a111b60$var$canvasDatabaseAriStaticOpts);
        return new _CanvasDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $bb75d6ce3a111b60$var$canvasDatabaseAriStaticOpts);
        return new _CanvasDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};
module.exports["CanvasDatabaseAri"] = $bb75d6ce3a111b60$export$b5af0e69d7a83a9e;

});

parcelRegister("9vfKf", function(module, exports) {
// src/canvas/database/types.ts
var $6eb338f0a74e11dd$export$21d39021bd86ec6f = "canvas", $6eb338f0a74e11dd$export$e7fab7e0dfc50566 = "database";
module.exports["CanvasDatabaseAriResourceOwner"] = $6eb338f0a74e11dd$export$21d39021bd86ec6f;
module.exports["CanvasDatabaseAriResourceType"] = $6eb338f0a74e11dd$export$e7fab7e0dfc50566;

});

parcelRegister("hlYjz", function(module, exports) {

var $gHLkd = parcelRequire("gHLkd");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/canvas/slide/manifest.ts
var $ca232f148426a545$var$canvasSlideAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $gHLkd.CanvasSlideAriResourceOwner),
    resourceType: (0, $gHLkd.CanvasSlideAriResourceType),
    resourceIdSlug: "{slideId}",
    resourceIdSegmentFormats: {
        slideId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/canvas/slide/index.ts
var $ca232f148426a545$export$31e0d39f56822976 = class _CanvasSlideAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get slideId() {
        return this._slideId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ca232f148426a545$var$canvasSlideAriStaticOpts.qualifier,
            platformQualifier: $ca232f148426a545$var$canvasSlideAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $ca232f148426a545$var$canvasSlideAriStaticOpts.resourceOwner,
            resourceType: $ca232f148426a545$var$canvasSlideAriStaticOpts.resourceType,
            resourceId: `${opts.slideId}`,
            resourceIdSegmentValues: {
                slideId: opts.slideId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $ca232f148426a545$var$canvasSlideAriStaticOpts);
        return new _CanvasSlideAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $ca232f148426a545$var$canvasSlideAriStaticOpts);
        return new _CanvasSlideAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            slideId: this.slideId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._slideId = opts.resourceIdSegmentValues.slideId;
    }
};
module.exports["CanvasSlideAri"] = $ca232f148426a545$export$31e0d39f56822976;

});

parcelRegister("gHLkd", function(module, exports) {
// src/canvas/slide/types.ts
var $c2955f3e4e17ee1c$export$55acbc4c2a211af8 = "canvas", $c2955f3e4e17ee1c$export$66742f5386e3198a = "slide";
module.exports["CanvasSlideAriResourceOwner"] = $c2955f3e4e17ee1c$export$55acbc4c2a211af8;
module.exports["CanvasSlideAriResourceType"] = $c2955f3e4e17ee1c$export$66742f5386e3198a;

});

parcelRegister("j5j6W", function(module, exports) {

var $5FPp0 = parcelRequire("5FPp0");

const $68bcf5e0dd294dcb$export$7af3c7e5c4c08291 = (0, $5FPp0.default);
module.exports["WhiteboardTokenQuery"] = $68bcf5e0dd294dcb$export$7af3c7e5c4c08291;

});

parcelRegister("5FPp0", function(module, exports) {
/**
 * @generated SignedSource<<351cfc5f593f05903a2295ed07018e0e>>
 * @relayHash a4627ffdde76fe559dd5d7e1dc1e4276
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a2a7d850fa8c1a6f919a6e61dafc3c775948c922f0c70a3fcecb66574478e38d
const $9d7efddcb99223f5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
        }
    ], v2 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v3 = [
        {
            "kind": "ScalarField",
            "name": "isEntitled"
        }
    ], v4 = [
        {
            "args": v1 /*: any*/ ,
            "concreteType": "CanvasToken",
            "kind": "LinkedField",
            "name": "canvasToken",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "token"
                }
            ]
        },
        {
            "args": v1 /*: any*/ ,
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "contentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaAccessTokens",
                    "kind": "LinkedField",
                    "name": "accessTokens",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readOnlyToken",
                            "plural": false,
                            "selections": v2 /*: any*/ 
                        },
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readWriteToken",
                            "plural": false,
                            "selections": v2 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "WhiteboardFeatures",
                    "kind": "LinkedField",
                    "name": "whiteboardFeatures",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SmartConnectorsFeature",
                            "kind": "LinkedField",
                            "name": "smartConnectors",
                            "plural": false,
                            "selections": v3 /*: any*/ 
                        },
                        {
                            "concreteType": "SmartSectionsFeature",
                            "kind": "LinkedField",
                            "name": "smartSections",
                            "plural": false,
                            "selections": v3 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "WhiteboardTokenQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "WhiteboardTokenQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "a4627ffdde76fe559dd5d7e1dc1e4276",
            "id": "a2a7d850fa8c1a6f919a6e61dafc3c775948c922f0c70a3fcecb66574478e38d",
            "metadata": {},
            "name": "WhiteboardTokenQuery",
            "operationKind": "query",
            "text": "query WhiteboardTokenQuery($contentId:ID!){canvasToken(contentId:$contentId){token},contentMediaSession(contentId:$contentId){accessTokens{readOnlyToken{value},readWriteToken{value}},configuration{fileStoreUrl}},entitlements{whiteboardFeatures{smartConnectors{isEntitled},smartSections{isEntitled}}}}"
        }
    };
}();
$9d7efddcb99223f5$var$node.hash = "b930e6a2afb104f531d81c694d4e3b98";
var $9d7efddcb99223f5$export$2e2bcd8739ae039 = $9d7efddcb99223f5$var$node;
module.exports["default"] = $9d7efddcb99223f5$export$2e2bcd8739ae039;

});

parcelRegister("i9cO2", function(module, exports) {

var $44GBW = parcelRequire("44GBW");

const $69a092ebfa4d47df$export$435620ef3a755b60 = (0, $44GBW.default);
module.exports["ExternalWhiteboardTokenQuery"] = $69a092ebfa4d47df$export$435620ef3a755b60;

});

parcelRegister("44GBW", function(module, exports) {
/**
 * @generated SignedSource<<4ca6c2a0ba179a389931392a013b83ba>>
 * @relayHash 54a5fc6e7c98e56377548628613e2156
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e4a2c4d0a490451b623e1067c2f4e785d8fb5ad621fe59faff5fdb574b5299b4
const $e5fc0566136ac68c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shareToken"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "shareToken",
            "variableName": "shareToken"
        }
    ], v2 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v3 = [
        {
            "kind": "ScalarField",
            "name": "isEntitled"
        }
    ], v4 = [
        {
            "args": v1 /*: any*/ ,
            "concreteType": "CanvasToken",
            "kind": "LinkedField",
            "name": "externalCanvasToken",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "token"
                }
            ]
        },
        {
            "args": v1 /*: any*/ ,
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "externalContentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaAccessTokens",
                    "kind": "LinkedField",
                    "name": "accessTokens",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readOnlyToken",
                            "plural": false,
                            "selections": v2 /*: any*/ 
                        },
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readWriteToken",
                            "plural": false,
                            "selections": v2 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "WhiteboardFeatures",
                    "kind": "LinkedField",
                    "name": "whiteboardFeatures",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SmartConnectorsFeature",
                            "kind": "LinkedField",
                            "name": "smartConnectors",
                            "plural": false,
                            "selections": v3 /*: any*/ 
                        },
                        {
                            "concreteType": "SmartSectionsFeature",
                            "kind": "LinkedField",
                            "name": "smartSections",
                            "plural": false,
                            "selections": v3 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalWhiteboardTokenQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalWhiteboardTokenQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "54a5fc6e7c98e56377548628613e2156",
            "id": "e4a2c4d0a490451b623e1067c2f4e785d8fb5ad621fe59faff5fdb574b5299b4",
            "metadata": {},
            "name": "ExternalWhiteboardTokenQuery",
            "operationKind": "query",
            "text": "query ExternalWhiteboardTokenQuery($shareToken:String!){externalCanvasToken(shareToken:$shareToken){token},externalContentMediaSession(shareToken:$shareToken){accessTokens{readOnlyToken{value},readWriteToken{value}},configuration{fileStoreUrl}},entitlements{whiteboardFeatures{smartConnectors{isEntitled},smartSections{isEntitled}}}}"
        }
    };
}();
$e5fc0566136ac68c$var$node.hash = "e61a3d3ef94ce6729beda61305e291be";
var $e5fc0566136ac68c$export$2e2bcd8739ae039 = $e5fc0566136ac68c$var$node;
module.exports["default"] = $e5fc0566136ac68c$export$2e2bcd8739ae039;

});

parcelRegister("5wU3V", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fcaWu = parcelRequire("fcaWu");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $9wGTI = parcelRequire("9wGTI");


var $cMmuo = parcelRequire("cMmuo");


var $7J5Uc = parcelRequire("7J5Uc");


var $bRwDd = parcelRequire("bRwDd");


var $cu6eG = parcelRequire("cu6eG");

const $3bf16ca42f9e188b$export$2bcebcd0d350d772 = ()=>{
    const appliedTheme = (0, $IQ4Dz.default)();
    const [{ isInitialized: themingInitialized }] = (0, $7J5Uc.useThemingState)();
    const effectiveThemeSerialized = (0, $cozmU.useMemo)(()=>{
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = Boolean(undefined);
        const theme = isSSR || !themingInitialized ? (0, $cMmuo.getSavedThemeLocal)() : appliedTheme;
        return theme ? (0, $fcaWu.themeObjectToString)(theme) : undefined;
    }, [
        themingInitialized,
        appliedTheme
    ]);
    // Value should always reflect the originally calculated value
    const initialThemeSerialized = (0, $cozmU.useRef)(effectiveThemeSerialized);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            (0, $cu6eG.whiteboardThemingService).dispose();
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (appliedTheme) (0, $cu6eG.whiteboardThemingService).updateTheme(appliedTheme);
    }, [
        appliedTheme
    ]);
    // When running inside an iframe (e.g. native embed whiteboard or database),
    // listen for theme changes from the parent page and apply them locally.
    // This bridges the gap where the parent's theme mutation is not visible to
    // `useThemeObserver` running inside this iframe's document.
    // Once applied, `useThemeObserver` above will detect the change and
    // propagate it via `whiteboardThemingService.updateTheme()`.
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_pass_theme_change_to_iframes')) return;
        if (window === window.parent) return;
        try {
            (0, $bRwDd.setupThemeInsideIframe)((iframeThemeInfo)=>{
                try {
                    (0, $bRwDd.applyThemeInsideIframe)(iframeThemeInfo, document);
                } catch  {
                // applyThemeInsideIframe manipulates DOM — if it fails the
                // iframe keeps its current theme which is an acceptable fallback.
                }
            });
        } catch  {
        // Expected in cross-origin iframes where window.parent properties
        // are inaccessible. Theme sync is not possible in that case and
        // the iframe will keep its initial theme from the URL query param.
        }
    }, []);
    return {
        themingService: (0, $cu6eG.whiteboardThemingService),
        initialThemeSerialized: initialThemeSerialized.current
    };
};
module.exports["useThemingService"] = $3bf16ca42f9e188b$export$2bcebcd0d350d772;

});

parcelRegister("cMmuo", function(module, exports) {

var $fzfTC = parcelRequire("fzfTC");

const $d56176af0bdf2d09$export$db80de5fdc8ebf2b = (0, $fzfTC.ThemeAPI).getSavedThemeLocal;
module.exports["getSavedThemeLocal"] = $d56176af0bdf2d09$export$db80de5fdc8ebf2b;

});

parcelRegister("cu6eG", function(module, exports) {
class $dc00d7996d97ffde$export$9c1453fd5233c0aa {
    dispose() {
        this.handlers.clear();
    }
    updateTheme(theme) {
        this.theme = theme;
        this.handlers.forEach((handler)=>handler(theme));
    }
    onThemeChange(cb) {
        this.handlers.add(cb);
        return ()=>{
            this.handlers.delete(cb);
        };
    }
    getTheme() {
        return this.theme;
    }
    constructor(){
        this.handlers = new Set();
        this.theme = undefined;
    }
}
const $dc00d7996d97ffde$export$add900538e5d49b8 = new $dc00d7996d97ffde$export$9c1453fd5233c0aa();
module.exports["whiteboardThemingService"] = $dc00d7996d97ffde$export$add900538e5d49b8;

});

parcelRegister("9Zj7l", function(module, exports) {

var $hysf6 = parcelRequire("hysf6");


var $aWwYt = parcelRequire("aWwYt");

const $b939c27ef0cabb4b$export$8a58354df2cc0213 = ()=>{
    const { showDetailsPanel: showDetailsPanel } = (0, $hysf6.useShowDetailsPanel)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const detailsPanelService = {
        showPanel: ()=>{
            showDetailsPanel();
        },
        hidePanel: ()=>{
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            hideObjectSidebar();
        }
    };
    return detailsPanelService;
};
module.exports["useDetailsPanelService"] = $b939c27ef0cabb4b$export$8a58354df2cc0213;

});

parcelRegister("7GbAd", function(module, exports) {

var $bm4Et = parcelRequire("bm4Et");


var $9lHB9 = parcelRequire("9lHB9");


var $gzMZq = parcelRequire("gzMZq");


var $cozmU = parcelRequire("cozmU");


var $gmOzQ = parcelRequire("gmOzQ");

const $9bddcff0c70982d7$export$ec2ef5433001a32a = (senderId)=>{
    if (!senderId) return undefined;
    if (senderId.startsWith('confluence-database')) return 'database';
    if (senderId.startsWith('confluence-whiteboards')) return 'whiteboard';
    return undefined;
};
const $9bddcff0c70982d7$export$c623484e6edc3170 = ()=>{
    const chatContextActions = (0, $gzMZq.useChatContextStoreActions)();
    const bindHandlersCallback = (0, $cozmU.useCallback)((on)=>{
        on((0, $gmOzQ.BoeSubmitPrompt), (data)=>{
            const bridgeAPI = (0, $bm4Et.getBrowserBridgeAPI)();
            const CONFLUENCE_AFM_CLIENT_ID = 'confluence-afm';
            // Register the staged content as the 'staging-area' target so
            // AFM's `populateSendMessageContext` emits whiteboard/database context.
            // Inferring contentType from senderId keeps this AFM-only (no canvas change).
            const contentId = data.contentId || '';
            const contentType = $9bddcff0c70982d7$export$ec2ef5433001a32a(data.senderId);
            if (contentId && contentType) chatContextActions.setTarget('staging-area', {
                id: contentId,
                type: contentType,
                canProvideContext: true
            });
            bridgeAPI.send((0, $9lHB9.InlineInputBoxSendMessageCommand), {
                senderId: CONFLUENCE_AFM_CLIENT_ID,
                receiverId: (0, $9lHB9.ROVO_CHAT_CLIENT_ID),
                prompt: data.prompt,
                source: 'CONFLUENCE_CWR_BLANK_OBJECT',
                productKey: 'confluence',
                deepResearchEnabled: false,
                webSearchEnabled: false,
                contentId: contentId,
                openChat: false,
                shouldStartNewConversation: true,
                addCurrentPageAsContextUserPreference: true,
                contentContext: 'staging-area',
                creationContextParams: {
                    shouldUseExistingContent: true,
                    experience: 'cwr_existing',
                    // Pass contentTypes so the backend knows which content type is being created.
                    ...contentType ? {
                        contentTypes: [
                            contentType
                        ]
                    } : {}
                }
            });
        });
    }, [
        chatContextActions
    ]);
    return bindHandlersCallback;
};
module.exports["useBoeSubmitPromptHandler"] = $9bddcff0c70982d7$export$c623484e6edc3170;

});

parcelRegister("gmOzQ", function(module, exports) {

var $bm4Et = parcelRequire("bm4Et");

const $34606c82d05fb0d2$export$9d080ab2cabc7598 = (0, $bm4Et.createCommand)('boe-submit-prompt');
module.exports["BoeSubmitPrompt"] = $34606c82d05fb0d2$export$9d080ab2cabc7598;

});

parcelRegister("8fSJ6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $27fJD = parcelRequire("27fJD");


var $6JLuV = parcelRequire("6JLuV");


var $6ET5o = parcelRequire("6ET5o");

const $b73182d5fc0f2f86$export$ca5fcf68ef635b5c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { open: openPreviewPanel } = (0, $6JLuV.useOpenPreviewPanel)();
    const bindHandlersCallback = (0, $cozmU.useCallback)((on)=>{
        // Handle OpenPreviewPanelCommand
        on((0, $6ET5o.OpenPreviewPanelCommand), (data)=>{
            const { url: url, ari: ari } = data;
            try {
                openPreviewPanel({
                    url: url,
                    ari: ari
                });
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'opened',
                        actionSubject: 'previewPanel',
                        actionSubjectId: 'open',
                        source: 'whiteboards-afm-bridge',
                        attributes: {
                            ari: ari
                        }
                    }
                }).fire();
            } catch (error) {
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'failed',
                        actionSubject: 'previewPanel',
                        actionSubjectId: 'open',
                        source: 'whiteboards-afm-bridge',
                        attributes: {
                            reason: 'open_preview_panel_error',
                            ari: ari,
                            error: error instanceof Error ? error.message : 'unknown_error'
                        }
                    }
                }).fire();
            }
        });
        // Handle IsPreviewPanelAvailableCommand
        on((0, $6ET5o.IsPreviewPanelAvailableCommand), (data)=>{
            const { ari: ari } = data;
            try {
                const available = (0, $27fJD.isPreviewPanelAvailable)({
                    ari: ari
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'checked',
                        actionSubject: 'previewPanel',
                        actionSubjectId: 'availability',
                        source: 'whiteboards-afm-bridge',
                        attributes: {
                            ari: ari,
                            isAvailable: available
                        }
                    }
                }).fire();
                return available;
            } catch (error) {
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'failed',
                        actionSubject: 'previewPanel',
                        actionSubjectId: 'checkAvailability',
                        source: 'whiteboards-afm-bridge',
                        attributes: {
                            reason: 'check_availability_error',
                            ari: ari,
                            error: error instanceof Error ? error.message : 'unknown_error'
                        }
                    }
                }).fire();
                return false;
            }
        });
    }, [
        createAnalyticsEvent,
        openPreviewPanel
    ]);
    return bindHandlersCallback;
};
module.exports["usePreviewPanelHandler"] = $b73182d5fc0f2f86$export$ca5fcf68ef635b5c;

});

parcelRegister("6ET5o", function(module, exports) {

var $bm4Et = parcelRequire("bm4Et");

const $6397e3353d5131f3$export$4575850911ab1ca9 = (0, $bm4Et.createCommand)('open-preview-panel');
const $6397e3353d5131f3$export$a1142d091bcf8405 = (0, $bm4Et.createCommand)('is-preview-panel-available');
const $6397e3353d5131f3$export$96e2dcb6ac19b762 = (0, $bm4Et.createCommand)('preview-panel-closed');
const $6397e3353d5131f3$export$b9dbf1961b27f6ad = (0, $bm4Et.createCommand)('preview-panel-opened');
module.exports["OpenPreviewPanelCommand"] = $6397e3353d5131f3$export$4575850911ab1ca9;
module.exports["IsPreviewPanelAvailableCommand"] = $6397e3353d5131f3$export$a1142d091bcf8405;
module.exports["PreviewPanelClosedMessage"] = $6397e3353d5131f3$export$96e2dcb6ac19b762;
module.exports["PreviewPanelOpenedMessage"] = $6397e3353d5131f3$export$b9dbf1961b27f6ad;

});

parcelRegister("01LnX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hdBxM = parcelRequire("hdBxM");


var $4m5jb = parcelRequire("4m5jb");


var $bGNkz = parcelRequire("bGNkz");


var $c5wKe = parcelRequire("c5wKe");


var $9aRNV = parcelRequire("9aRNV");


var $1AJi3 = parcelRequire("1AJi3");


var $au2Go = parcelRequire("au2Go");

const $9389f957f4a5b3af$export$16ae08328af9f0f7 = ()=>{
    const { toggleConversationAssistant: toggleConversationAssistant, isConversationAssistantSidebarActive: isConversationAssistantSidebarActive } = (0, $1AJi3.useToggleConversationAssistant)();
    const { streaming: streaming, setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStore)();
    const { setSelectedConversation: setSelectedConversation } = (0, $c5wKe.useSmartCreationChatStoreApi)();
    const { actions: actions } = (0, $9aRNV.useConversationActionsStoreState)();
    const publishActions = (0, $hdBxM.usePublish)('ai-mate-actions');
    const publishChat = (0, $hdBxM.usePublish)('ai-mate');
    // Use a ref so the command handler always reads the latest sidebar state
    // without needing isConversationAssistantSidebarActive in useCallback deps
    // (which would cause handler re-registration and missed/duplicate events)
    const isSidebarActiveRef = (0, $cozmU.useRef)(isConversationAssistantSidebarActive);
    isSidebarActiveRef.current = isConversationAssistantSidebarActive;
    const [pendingActionId, setPendingActionId] = (0, $cozmU.useState)(undefined);
    const [pendingPrefillPrompt, setPendingPrefillPrompt] = (0, $cozmU.useState)(undefined);
    // Publish pending action once sidebar is open and actions are loaded
    (0, $cozmU.useEffect)(()=>{
        if (pendingActionId && isConversationAssistantSidebarActive && actions.length > 0) {
            // Uses setTimeout to ensure the component has fully rendered
            // Not doing this results in a mixed state where the sidebar thinks it's in a nested action but is displaying the actions visible at the root	level
            const timeoutId = setTimeout(()=>{
                publishActions({
                    type: 'select-action',
                    source: 'whiteboard-rovo-bridge',
                    data: {
                        actionId: pendingActionId
                    }
                });
                setPendingActionId(undefined);
            }, 0);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        pendingActionId,
        isConversationAssistantSidebarActive,
        actions,
        publishActions
    ]);
    // Publish pending prefill prompt once sidebar is open
    (0, $cozmU.useEffect)(()=>{
        if (pendingPrefillPrompt && isConversationAssistantSidebarActive) {
            const timeoutId = setTimeout(()=>{
                publishChat({
                    type: 'insert-prompt',
                    source: 'whiteboard-rovo-bridge',
                    data: {
                        prompt: pendingPrefillPrompt,
                        overrideAutoSend: true
                    }
                });
                setPendingPrefillPrompt(undefined);
            }, 0);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        pendingPrefillPrompt,
        isConversationAssistantSidebarActive,
        publishChat
    ]);
    return (0, $cozmU.useCallback)((on)=>{
        on((0, $au2Go.OpenRovoSidePanelCommand), ({ actionId: actionId, prefillPrompt: prefillPrompt })=>{
            // Don't set action if currently streaming
            if (!streaming && actionId) {
                setPendingActionId(actionId);
                setSelectedConversation({
                    conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
                });
                setActiveMenu('none');
            }
            if (prefillPrompt) setPendingPrefillPrompt(prefillPrompt);
            // Use ref to read latest sidebar state without causing handler re-registration
            if (!isSidebarActiveRef.current) toggleConversationAssistant('sidebar');
        });
    }, [
        streaming,
        toggleConversationAssistant,
        setSelectedConversation,
        setActiveMenu
    ]);
};
module.exports["useOpenRovoSidePanelHandler"] = $9389f957f4a5b3af$export$16ae08328af9f0f7;

});

parcelRegister("au2Go", function(module, exports) {

var $bm4Et = parcelRequire("bm4Et");

const $2a0acf14f8de804a$export$d6bae569fab8e805 = (0, $bm4Et.createCommand)('open-rovo-side-panel');
module.exports["OpenRovoSidePanelCommand"] = $2a0acf14f8de804a$export$d6bae569fab8e805;

});


//# sourceMappingURL=ExternalSharePage.dbcf2b78.js.map
